import React from "react";

// pass { id } prop when using case "refersh", with appropriate id
const SvgIcons = ({ type, id, className = "", color = "black" }) => {
  switch (type) {
    case "phone": {
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
        </>
      );
    }
    case "email": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="23"
            viewBox="0 0 24 23"
          >
            <defs>
              <clipPath id="clipPath">
                <rect
                  id="Rectangle_6"
                  dataName="Rectangle 6"
                  width="24"
                  height="23"
                  transform="translate(-1)"
                  fill="#16346c"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_3"
              dataName="Mask Group 3"
              transform="translate(1)"
              clipPath="url(#clipPath)"
            >
              <path
                id="at_3_"
                dataName="at (3)"
                d="M11.5,0A11.509,11.509,0,0,0,0,11.5C-.121,20.668,10.691,26.278,18.107,20.9A.958.958,0,1,0,17,19.336c-6.177,4.477-15.183-.2-15.087-7.84.526-12.709,18.637-12.707,19.161,0v1.916a1.916,1.916,0,0,1-3.832,0V11.5C17,3.9,5.989,3.9,5.748,11.5a5.765,5.765,0,0,0,10.079,3.768,3.832,3.832,0,0,0,7.166-1.852V11.5A11.509,11.509,0,0,0,11.5,0Zm0,15.329A3.832,3.832,0,1,1,15.329,11.5,3.832,3.832,0,0,1,11.5,15.329Z"
                transform="translate(-0.423)"
                fill="#16346c"
              />
            </g>
          </svg>
        </>
      );
    }
    case "email_enevlope": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_13586"
                  data-name="Rectangle 13586"
                  width="14"
                  height="14"
                  transform="translate(-9396 1627)"
                  fill="#fff"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_38541"
              data-name="Mask Group 38541"
              transform="translate(9396 -1627)"
              clip-path="url(#clip-path)"
            >
              <g
                id="_01_align_center"
                data-name="01 align center"
                transform="translate(-9396 1627)"
              >
                <path
                  id="Path_28660"
                  data-name="Path 28660"
                  d="M12.25.583H1.75A1.75,1.75,0,0,0,0,2.333V13.417H14V2.333A1.75,1.75,0,0,0,12.25.583ZM1.75,1.75h10.5a.583.583,0,0,1,.583.583v.389l-4.6,4.6a1.754,1.754,0,0,1-2.476,0l-4.6-4.6V2.333A.583.583,0,0,1,1.75,1.75Zm-.583,10.5V4.375L4.937,8.143a2.921,2.921,0,0,0,4.125,0l3.771-3.768V12.25Z"
                  fill="#1b2430"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "message": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-mails"
          >
            <rect width="16" height="13" x="6" y="4" rx="2" />
            <path d="m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7" />
            <path d="M2 8v11c0 1.1.9 2 2 2h14" />
          </svg>
        </>
      );
    }
    case "email_enevlope_open": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-mail-open"
          >
            <path d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
            <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
          </svg>
        </>
      );
    }
    case "resendEmail": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            width="512"
            height="512"
          >
            <g>
              <path d="M30.118,323.342v0.423h256c8.317,0,15.059,6.742,15.059,15.059c0,8.317-6.742,15.059-15.059,15.059H15.059   C6.742,353.883,0,347.14,0,338.824v-22.466c0-0.076,0-0.152,0-0.227V67.765c0-8.317,6.742-15.059,15.059-15.059h406.588   c8.317,0,15.059,6.742,15.059,15.059v165.647c0,8.317-6.742,15.059-15.059,15.059s-15.059-6.742-15.059-15.059v-97.21   l-92.502,71.946l41.853,34.467c6.42,5.287,7.338,14.778,2.051,21.197c-5.287,6.42-14.778,7.339-21.197,2.051l-47.072-38.765   l-62.123,48.318c-5.438,4.23-13.052,4.23-18.49,0l-62.123-48.318L30.118,323.342L30.118,323.342z M30.118,284.326L30.118,284.326   l92.502-76.178l-92.502-71.946V284.326z M218.353,244.452L406.589,98.047V82.824H30.118v15.223L218.353,244.452z M361.412,392.821   l11.94-11.94c5.881-5.881,15.416-5.881,21.296,0c5.881,5.88,5.881,15.415,0,21.296l-37.647,37.647   c-5.881,5.881-15.416,5.881-21.296,0l-37.647-37.647c-5.881-5.88-5.881-15.415,0-21.296c5.881-5.881,15.416-5.881,21.296,0   l11.94,11.94v-23.88c0-49.901,40.452-90.353,90.353-90.353S512,319.041,512,368.941s-40.452,90.353-90.353,90.353   c-8.317,0-15.059-6.742-15.059-15.059c0-8.317,6.742-15.059,15.059-15.059c33.267,0,60.235-26.968,60.235-60.235   s-26.968-60.235-60.235-60.235s-60.235,26.968-60.235,60.235V392.821z" />
            </g>
          </svg>
        </>
      );
    }
    case "circleHelp": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-help"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <path d="M12 17h.01" />
          </svg>
        </>
      );
    }
    case "removeCircle": {
      return (
        <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="12" cy="12" r="10" stroke="red" stroke-width="2" /> <line x1="8" y1="8" x2="16" y2="16" stroke="red" stroke-width="2" /> <line x1="16" y1="8" x2="8" y2="16" stroke="red" stroke-width="2" /> </svg>
        </>
      )
    }

    case "doller": {
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign-icon lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
        </>
      )
    }
    case "circle": {
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-icon lucide-circle"><circle cx="12" cy="12" r="10" /></svg>
        </>
      )
    }

    case "type": {
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-log-in-icon lucide-log-in"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" x2="3" y1="12" y2="12" /></svg>
        </>
      )
    }

    case "appointment": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              opacity="0.4"
              d="M35.8346 21.262V20.406C35.8346 17.5237 35.8346 15.2134 35.7041 13.334H4.29844C4.16797 15.2134 4.16797 17.5237 4.16797 20.406V21.262C4.16797 28.5242 4.16797 32.1552 6.25484 34.4113C8.3417 36.6673 11.7005 36.6673 18.418 36.6673H21.5846C28.3021 36.6673 31.661 36.6673 33.7478 34.4113C35.8346 32.1552 35.8346 28.5242 35.8346 21.262Z"
              fill="#0376F6"
            />
            <path
              d="M30 3.33398V6.66732M10 3.33398V6.66732"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.9912 21.666H20.0062M19.9912 28.3327H20.0062M26.6504 21.666H26.6654M13.332 21.666H13.347M13.332 28.3327H13.347"
              stroke="#0376F6"
              strokeWidth="3.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.83203 13.334H34.1654"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.16797 20.4053C4.16797 13.1432 4.16797 9.51213 6.25484 7.25607C8.3417 5 11.7005 5 18.418 5H21.5846C28.3021 5 31.661 5 33.7478 7.25607C35.8346 9.51213 35.8346 13.1432 35.8346 20.4053V21.2613C35.8346 28.5235 35.8346 32.1545 33.7478 34.4107C31.661 36.6667 28.3021 36.6667 21.5846 36.6667H18.418C11.7005 36.6667 8.3417 36.6667 6.25484 34.4107C4.16797 32.1545 4.16797 28.5235 4.16797 21.2613V20.4053Z"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 13.334H35"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      );
    }
    case "selectService": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              opacity="0.4"
              d="M26.0995 32.139C28.7182 30.2007 30.7804 28.1927 32.3609 26.1888L23.1522 15.7413C22.7752 15.3137 22.1442 15.2216 21.6607 15.5237L18.0172 17.801C16.735 18.6023 15.0709 18.422 13.9902 17.3645C12.5626 15.9677 12.7067 13.6295 14.2949 12.4184L19.9984 8.0693L18.2747 6.78002C15.9314 5.02019 12.0305 3.91539 7.5611 6.65692C1.69548 10.2549 0.36823 22.1248 13.8979 32.139C16.4749 34.0463 17.7634 35 19.9987 35C22.234 35 23.5225 34.0463 26.0995 32.139Z"
              fill="#0376F6"
            />
            <path
              d="M32.3609 26.1888C38.9454 17.8397 37.1665 9.55847 32.4364 6.65692C27.9669 3.91539 24.066 5.02019 21.7227 6.78002L19.9984 8.0693M32.3609 26.1888C30.7804 28.1927 28.7182 30.2007 26.0995 32.139C23.5225 34.0463 22.234 35 19.9987 35C17.7634 35 16.4749 34.0463 13.8979 32.139C0.36823 22.1248 1.69548 10.2549 7.5611 6.65692C12.0305 3.91539 15.9314 5.02019 18.2747 6.78002L19.9984 8.0693M32.3609 26.1888L23.1522 15.7413C22.7752 15.3137 22.1442 15.2216 21.6607 15.5237L18.0172 17.801C16.735 18.6023 15.0709 18.422 13.9902 17.3645C12.5626 15.9677 12.7067 13.6295 14.2949 12.4184L19.9984 8.0693"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      );
    }
    case "confirmDetails": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              opacity="0.4"
              d="M19.2144 36.6673H17.4497C10.7945 36.6673 7.467 36.6673 5.39951 34.7146C3.33203 32.7621 3.33203 29.6193 3.33203 23.334V16.6673C3.33203 10.3819 3.33203 7.23923 5.39951 5.2866C7.467 3.33398 10.7946 3.33398 17.4497 3.33398H26.6652C26.9314 3.33398 27.1939 3.34958 27.4519 3.3799C23.2632 3.81958 19.9987 7.36222 19.9987 11.6673C19.9987 16.2697 23.7297 20.0007 28.332 20.0007C30.208 20.0007 31.9392 19.3808 33.3319 18.3347V24.0315C33.329 29.8547 33.254 32.8356 31.2645 34.7146C29.197 36.6673 25.8695 36.6673 19.2144 36.6673Z"
              fill="#0376F6"
            />
            <path
              d="M25 12.4993C25 12.4993 25.8333 12.4993 26.6667 14.166C26.6667 14.166 29.3137 9.99935 31.6667 9.16602"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36.6667 11.6673C36.6667 16.2697 32.9357 20.0007 28.3333 20.0007C23.731 20.0007 20 16.2697 20 11.6673C20 7.06495 23.731 3.33398 28.3333 3.33398C32.9357 3.33398 36.6667 7.06495 36.6667 11.6673Z"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M17.3325 3.36906C13.1684 3.19274 9.27361 3.67176 9.27361 3.67176C7.24219 3.81701 3.34918 4.95589 3.34921 11.607C3.34924 18.2017 3.30614 26.3315 3.34921 29.5727C3.34921 31.5527 4.57524 36.1717 8.81884 36.4192C13.9769 36.72 23.2678 36.784 27.5308 36.4192C28.6718 36.3549 32.471 35.459 32.9518 31.3255C33.45 27.0434 33.3508 24.0672 33.3508 23.3589"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.668 21.666H18.3346"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M11.668 28.334H25.0013"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </>
      );
    }
    case "uploadDocuments": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              opacity="0.4"
              d="M34.3349 21.3507C33.7675 22.744 31.1539 25.5035 25.1739 25.5035C24.6715 25.5035 23.3537 26.0088 23.4219 28.7472C23.4497 31.2222 22.5475 36.1185 18.763 36.3297C18.0132 36.3333 17.1979 36.3333 16.3069 36.3333C13.3085 36.3333 11.8093 36.3333 10.6119 35.913C8.68689 35.2373 7.16849 33.8082 6.45051 31.9965C6.00391 30.8695 6.00391 29.4585 6.00391 26.6363V11.3333C6.00391 9.78448 6.00391 9.01005 6.13201 8.36607C6.65806 5.72145 8.72537 3.65413 11.37 3.1281C12.014 3 12.7884 3 14.3372 3H21.4585C26.8939 3 29.6115 3 31.4989 4.32973C32.0395 4.71072 32.5197 5.16255 32.9244 5.67148C34.3372 7.44778 34.3372 10.0056 34.3372 15.1212V19.3637C34.3372 20.0753 34.3372 20.7357 34.3349 21.3507Z"
              fill="#0376F6"
            />
            <path
              d="M21 3H21.4545C26.8898 3 29.6075 3 31.4948 4.32973C32.0357 4.71072 32.5157 5.16253 32.9205 5.67148C34.3333 7.44778 34.3333 10.0056 34.3333 15.1212V19.3637C34.3333 24.3023 34.3333 26.7715 33.5518 28.7437C32.2953 31.9143 29.6382 34.4152 26.2693 35.5977C24.174 36.3333 21.5503 36.3333 16.303 36.3333C13.3046 36.3333 11.8054 36.3333 10.608 35.913C8.68298 35.2373 7.16458 33.8082 6.4466 31.9965C6 30.8695 6 29.4585 6 26.6363V19.6667"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34.3346 19.666C34.3346 22.7342 31.8473 25.2215 28.7791 25.2215C27.6695 25.2215 26.3613 25.0272 25.2823 25.3162C24.3238 25.573 23.575 26.3218 23.3181 27.2803C23.0291 28.3593 23.2235 29.6675 23.2235 30.7772C23.2235 33.8453 20.7361 36.3327 17.668 36.3327"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.66797 7.16667C8.48719 6.32383 10.6676 3 11.8346 3M11.8346 3C13.0017 3 15.1821 6.32383 16.0013 7.16667M11.8346 3V16.3333"
              stroke="#0376F6"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
      );
    }


    // social icon
    case "twitter": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-twitter"
          >
            <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
          </svg>
        </>
      );
    }
    case "linkdin": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-linkedin"
          >
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
            <rect width="4" height="12" x="2" y="9" />
            <circle cx="4" cy="4" r="2" />
          </svg>
        </>
      );
    }
    case "facebook": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-facebook"
          >
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
        </>
      );
    }
    case "instagram": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-instagram"
          >
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
        </>
      );
    }
    case "chevronRight": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </>
      );
    }
    case "chevronLeft": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </>
      );
    }
    case "chevronDown": {
      return (
        <>
          <svg
            className={`lucide lucide-chevron-down ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </>
      );
    }
    case "chevronUp": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-up"
          >
            <path d="m18 15-6-6-6 6" />
          </svg>
        </>
      );
    }
    case "backArrow": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            classNameName="lucide lucide-chevron-left"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </>
      );
    }
    case "notification": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
          >
            <g
              id="Group_37764"
              dataName="Group 37764"
              transform="translate(0 0)"
            >
              <rect
                id="Rectangle_16"
                dataName="Rectangle 16"
                width="17"
                height="17"
                transform="translate(0 0)"
                fill="none"
              />
              <g
                id="Group_24"
                dataName="Group 24"
                transform="translate(0.754 0.888)"
              >
                <path
                  id="Path_12"
                  dataName="Path 12"
                  d="M15.341,13.118h1.482V14.6H2V13.118H3.482V7.93a5.93,5.93,0,1,1,11.859,0Zm-1.482,0V7.93a4.447,4.447,0,1,0-8.894,0v5.188ZM7.188,16.083h4.447v1.482H7.188Z"
                  transform="translate(-2 -2)"
                  strokeWidth="0.2"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "setting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#1b2430"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-settings"
          >
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </>
      );
    }
    case "pencil": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-pencil"
          >
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
            <path d="m15 5 4 4" />
          </svg>
        </>
      );
    }
    case "filterIcon": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-sliders-horizontal"
          >
            <line x1="21" x2="14" y1="4" y2="4" />
            <line x1="10" x2="3" y1="4" y2="4" />
            <line x1="21" x2="12" y1="12" y2="12" />
            <line x1="8" x2="3" y1="12" y2="12" />
            <line x1="21" x2="16" y1="20" y2="20" />
            <line x1="12" x2="3" y1="20" y2="20" />
            <line x1="14" x2="14" y1="2" y2="6" />
            <line x1="8" x2="8" y1="10" y2="14" />
            <line x1="16" x2="16" y1="18" y2="22" />
          </svg>
        </>
      );
    }
    case "refresh": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-refresh-cw"
            id={id}
          >
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M8 16H3v5" />
          </svg>
        </>
      );
    }
    case "editIcon": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.822"
            height="14.698"
            viewBox="0 0 14.822 14.698"
          >
            <g
              id="Group_38886"
              dataName="Group 38886"
              transform="translate(-1876.602 -260.7)"
            >
              <rect
                id="Rectangle_13322"
                dataName="Rectangle 13322"
                width="13.835"
                height="13.835"
                transform="translate(1877 261)"
                fill="none"
              />
              <path
                id="_728966_edit_pen_pencil_writing_draw_icon"
                dataName="728966_edit_pen_pencil_writing_draw_icon"
                d="M13.488,1.75,12.25.513a1.75,1.75,0,0,0-2.475,0L2.262,8.025A6.26,6.26,0,0,0,.875,10.137L0,14l3.862-.875a21.319,21.319,0,0,0,2.112-1.388l7.513-7.513A1.75,1.75,0,0,0,13.488,1.75ZM1.16,12.84l.568-2.51a.868.868,0,0,0,.018-.109c0-.005.006-.013.009-.018l1.979,1.979-.2.12Zm4.2-1.723a8.706,8.706,0,0,1-.86.592L2.23,9.442a7.857,7.857,0,0,1,.651-.8L8.538,2.987l2.475,2.475Zm7.511-7.511L11.631,4.843,9.157,2.369l1.238-1.237a.875.875,0,0,1,1.237,0l1.237,1.237a.875.875,0,0,1,0,1.237Z"
                transform="translate(1877 261)"
                fill="#4b96cd"
                stroke="#4b96cd"
                strokeWidth="0.6"
              />
            </g>
          </svg>
        </>
      );
    }
    case "cross": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </>
      );
    }
    case "mapMarker": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className={`lucide lucide-map-pin ${className}`}
          >
            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </>
      );
    }
    case "globe": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
        </>
      );
    }
    case "link": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-link"
          >
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </>
      );
    }
    case "TotalExpense": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.424"
            height="27.417"
            viewBox="0 0 27.424 27.417"
          >
            <g
              id="Group_39256"
              data-name="Group 39256"
              transform="translate(0.25 0.25)"
            >
              <g id="Group_39255" data-name="Group 39255">
                <path
                  id="Path_28631"
                  data-name="Path 28631"
                  d="M2646.948,989.359V974.166c.01-.015.026-.028.028-.044a2.472,2.472,0,0,1,2.628-2.129c.533.022,1.068.015,1.6,0a1.192,1.192,0,0,0,.539-.142c2.7-1.563,5.386-3.156,8.1-4.7a32.566,32.566,0,0,1,4.557-2.5h.631a2.981,2.981,0,0,1,2.163,1.762c1,1.808,2.046,3.589,3.066,5.385a.474.474,0,0,0,.384.264,2.2,2.2,0,0,1,1.1.51,2.476,2.476,0,0,1,.9,2.015c0,1.13,0,2.26,0,3.391a.32.32,0,0,0,.2.343,1.723,1.723,0,0,1,1.016,1.6q.029,1.866,0,3.732a1.733,1.733,0,0,1-1.021,1.594.3.3,0,0,0-.195.317q.009,1.7,0,3.391a2.628,2.628,0,0,1-.251,1.222,2.436,2.436,0,0,1-2.318,1.393q-4.429.006-8.858,0-5.835,0-11.67,0a2.5,2.5,0,0,1-2.119-1.008A2.85,2.85,0,0,1,2646.948,989.359Zm24.452-3.906h-.356c-1.218-.009-2.438.036-3.651-.038a3.661,3.661,0,0,1,.375-7.3c1.113-.009,2.225,0,3.338,0h.291a1.473,1.473,0,0,0,.018-.152c0-1.156.011-2.313,0-3.469a1.214,1.214,0,0,0-1.353-1.271q-10.262,0-20.525,0a1.782,1.782,0,0,0-.417.037,1.251,1.251,0,0,0-.948,1.363q0,6.386,0,12.772,0,.815,0,1.629a1.151,1.151,0,0,0,.548,1.1,1.968,1.968,0,0,0,.9.222q10.184.018,20.368.009a2.575,2.575,0,0,0,.314-.014,1.152,1.152,0,0,0,1.1-1.08C2671.417,988,2671.4,986.749,2671.4,985.453Zm-1.651-1.247v.016c.7,0,1.4,0,2.1,0,.571,0,.793-.223.794-.794q0-1.642,0-3.285c0-.586-.226-.814-.805-.815-1.313,0-2.627-.009-3.941.006a3.513,3.513,0,0,0-.9.136,2.424,2.424,0,0,0,.546,4.729C2668.277,984.235,2669.014,984.206,2669.749,984.206Zm-3.948-17.722a1.184,1.184,0,0,0-1.708-.4q-4.958,2.882-9.912,5.771c-.048.028-.09.065-.2.142.742,0,1.413.009,2.082-.006a1.116,1.116,0,0,0,.515-.137q4.5-2.6,8.986-5.224C2665.642,966.586,2665.714,966.539,2665.8,966.484Zm-6.918,5.454.018.058c.687,0,1.375.007,2.062-.005a.953.953,0,0,0,.441-.121q2.7-1.56,5.4-3.137c.073-.042.141-.092.219-.143l-.6-1.043Zm8.752-2.276-3.964,2.312h5.285Z"
                  transform="translate(-2646.948 -964.65)"
                  stroke-width="0.5"
                />
                <path
                  id="Path_28632"
                  data-name="Path 28632"
                  d="M2920.761,1186.219a1.218,1.218,0,1,1-1.215,1.222A1.223,1.223,0,0,1,2920.761,1186.219Z"
                  transform="translate(-2899.968 -1170.306)"
                  stroke-width="0.2"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "Transactions": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.031"
            height="23.718"
            viewBox="0 0 29.031 23.718"
          >
            <g
              id="Group_39254"
              data-name="Group 39254"
              transform="translate(0 0)"
            >
              <g
                id="Path_28629"
                data-name="Path 28629"
                transform="translate(1388.286 898.41)"
              >
                <path
                  d="M -1365.074829101562 -886.9522705078125 C -1365.419189453125 -886.9522705078125 -1365.7490234375 -887.0955200195312 -1366.003662109375 -887.3555297851562 C -1366.509399414062 -887.8717041015625 -1366.501098632812 -888.6611328125 -1365.984375 -889.19189453125 C -1365.643310546875 -889.5420532226562 -1365.288330078125 -889.8912963867188 -1364.945068359375 -890.22900390625 C -1364.769897460938 -890.4012451171875 -1364.594848632812 -890.5735473632812 -1364.420654296875 -890.7467651367188 C -1364.368774414062 -890.7984008789062 -1364.318969726562 -890.8523559570312 -1364.255859375 -890.920654296875 C -1364.220092773438 -890.9592895507812 -1364.179321289062 -891.0034790039062 -1364.13037109375 -891.0557250976562 L -1363.893432617188 -891.308349609375 L -1364.23974609375 -891.308349609375 L -1364.698974609375 -891.308349609375 L -1368.00537109375 -891.3082885742188 L -1370.533081054688 -891.3082275390625 C -1374.552978515625 -891.3082275390625 -1377.6572265625 -891.3087768554688 -1382.541381835938 -891.311767578125 C -1382.7421875 -891.311767578125 -1383.002319335938 -891.3208618164062 -1383.234008789062 -891.3920288085938 C -1383.831909179688 -891.5756225585938 -1384.185546875 -892.166259765625 -1384.093872070312 -892.8284301757812 C -1384.014404296875 -893.4026489257812 -1383.504638671875 -893.8668823242188 -1382.908081054688 -893.9083251953125 C -1382.857421875 -893.9118041992188 -1382.80224609375 -893.9133911132812 -1382.72900390625 -893.9133911132812 C -1382.69873046875 -893.9133911132812 -1382.668334960938 -893.9131469726562 -1382.638061523438 -893.9129028320312 C -1382.60693359375 -893.9126586914062 -1382.575927734375 -893.912353515625 -1382.544921875 -893.912353515625 C -1375.263916015625 -893.91259765625 -1371.983154296875 -893.91259765625 -1364.7021484375 -893.91259765625 L -1364.242431640625 -893.91259765625 L -1363.88232421875 -893.91259765625 L -1364.135986328125 -894.1682739257812 C -1364.337646484375 -894.3716430664062 -1364.534545898438 -894.5690307617188 -1364.727661132812 -894.7626953125 C -1365.172485351562 -895.2086181640625 -1365.592529296875 -895.6298217773438 -1366.007934570312 -896.0594482421875 C -1366.390502929688 -896.455078125 -1366.483764648438 -897.0304565429688 -1366.245483398438 -897.525390625 C -1366.030395507812 -897.9718627929688 -1365.599609375 -898.2603149414062 -1365.14794921875 -898.2603149414062 C -1365.08740234375 -898.2603149414062 -1365.026000976562 -898.2552490234375 -1364.965454101562 -898.2451782226562 C -1364.651000976562 -898.1931762695312 -1364.339111328125 -898.0473022460938 -1364.151489257812 -897.8645629882812 C -1362.597290039062 -896.3543090820312 -1361.0791015625 -894.8244018554688 -1359.798950195312 -893.527099609375 C -1359.27490234375 -892.99609375 -1359.276000976562 -892.2255249023438 -1359.801391601562 -891.6947631835938 C -1361.22021484375 -890.2610473632812 -1362.682495117188 -888.7989501953125 -1364.147705078125 -887.3489379882812 C -1364.406127929688 -887.0931396484375 -1364.7353515625 -886.9522705078125 -1365.074829101562 -886.9522705078125 Z"
                  stroke="none"
                />
                <path
                  d="M -1365.14794921875 -898.1103515625 L -1365.14794921875 -898.1103515625 C -1365.542358398438 -898.1102905273438 -1365.920166015625 -897.8551635742188 -1366.1103515625 -897.4602661132812 C -1366.321166992188 -897.0226440429688 -1366.238525390625 -896.5137329101562 -1365.900024414062 -896.1636962890625 C -1365.485473632812 -895.7349243164062 -1365.065795898438 -895.3141479492188 -1364.62158203125 -894.86865234375 C -1364.428344726562 -894.6749267578125 -1364.231323242188 -894.4773559570312 -1364.029418945312 -894.2738647460938 L -1363.522338867188 -893.7626342773438 L -1364.7021484375 -893.7626342773438 C -1371.983154296875 -893.7626342773438 -1375.263916015625 -893.7626342773438 -1382.544921875 -893.7623901367188 C -1382.606079101562 -893.7623901367188 -1382.667724609375 -893.7633666992188 -1382.729125976562 -893.7633666992188 C -1382.798706054688 -893.7633666992188 -1382.850708007812 -893.761962890625 -1382.897705078125 -893.7587280273438 C -1383.416381835938 -893.72265625 -1383.87646484375 -893.3049926757812 -1383.9453125 -892.807861328125 C -1384.026611328125 -892.22021484375 -1383.716064453125 -891.6969604492188 -1383.190063476562 -891.5354614257812 C -1382.977294921875 -891.4700927734375 -1382.731689453125 -891.4617309570312 -1382.541381835938 -891.4617309570312 C -1377.669921875 -891.4588012695312 -1374.562744140625 -891.458251953125 -1370.533081054688 -891.458251953125 L -1363.547119140625 -891.4583129882812 L -1364.020874023438 -890.953125 C -1364.069580078125 -890.9011840820312 -1364.110107421875 -890.8572998046875 -1364.145751953125 -890.81884765625 C -1364.2099609375 -890.749267578125 -1364.2607421875 -890.6943359375 -1364.314819335938 -890.6404418945312 C -1364.4892578125 -890.4669799804688 -1364.66455078125 -890.2945556640625 -1364.83984375 -890.1220703125 C -1365.1826171875 -889.784912109375 -1365.536987304688 -889.436279296875 -1365.876831054688 -889.0872192382812 C -1366.335327148438 -888.6163330078125 -1366.34375 -887.9169921875 -1365.896484375 -887.4605102539062 C -1365.670288085938 -887.2294921875 -1365.378540039062 -887.102294921875 -1365.074829101562 -887.102294921875 C -1364.775146484375 -887.102294921875 -1364.4833984375 -887.2277221679688 -1364.253295898438 -887.45556640625 C -1362.788452148438 -888.9051513671875 -1361.326538085938 -890.366943359375 -1359.907958984375 -891.80029296875 C -1359.435546875 -892.277587890625 -1359.4345703125 -892.9443359375 -1359.905639648438 -893.4217529296875 C -1361.185302734375 -894.718505859375 -1362.702880859375 -896.2476806640625 -1364.256225585938 -897.7571411132812 C -1364.420532226562 -897.9171752929688 -1364.70849609375 -898.0506591796875 -1364.989990234375 -898.0972290039062 C -1365.042358398438 -898.1058959960938 -1365.095581054688 -898.1103515625 -1365.14794921875 -898.1103515625 M -1365.14794921875 -898.4103393554688 C -1365.079833984375 -898.4103393554688 -1365.010620117188 -898.4047241210938 -1364.94091796875 -898.3931884765625 C -1364.625244140625 -898.3409423828125 -1364.272216796875 -898.1915283203125 -1364.046875 -897.9720458984375 C -1362.577392578125 -896.5440673828125 -1361.131591796875 -895.0911865234375 -1359.692138671875 -893.6324462890625 C -1359.10693359375 -893.0394287109375 -1359.111328125 -892.1785888671875 -1359.69482421875 -891.5892333984375 C -1361.13623046875 -890.1326904296875 -1362.58544921875 -888.6839599609375 -1364.042236328125 -887.2423095703125 C -1364.644897460938 -886.6458129882812 -1365.535278320312 -886.6627807617188 -1366.11083984375 -887.2506103515625 C -1366.66845703125 -887.8197021484375 -1366.667724609375 -888.7049560546875 -1366.091796875 -889.2965087890625 C -1365.57861328125 -889.8236083984375 -1365.04833984375 -890.3341064453125 -1364.5263671875 -890.8531494140625 C -1364.44873046875 -890.9305419921875 -1364.375732421875 -891.0133056640625 -1364.23974609375 -891.1583251953125 L -1364.698974609375 -891.1583251953125 C -1371.9794921875 -891.1582641601562 -1375.260864257812 -891.1573486328125 -1382.54150390625 -891.1617431640625 C -1382.787841796875 -891.1617431640625 -1383.045166015625 -891.1771240234375 -1383.278076171875 -891.2486572265625 C -1383.953125 -891.4559326171875 -1384.342529296875 -892.1258544921875 -1384.242431640625 -892.8489990234375 C -1384.154052734375 -893.4881591796875 -1383.58251953125 -894.0118408203125 -1382.91845703125 -894.0579833984375 C -1382.794311523438 -894.0664672851562 -1382.669067382812 -894.0623168945312 -1382.544921875 -894.0623779296875 C -1375.263916015625 -894.0626220703125 -1371.983154296875 -894.0626220703125 -1364.7021484375 -894.0626220703125 L -1364.242431640625 -894.0626220703125 C -1364.906494140625 -894.7320556640625 -1365.51806640625 -895.3370361328125 -1366.11572265625 -895.9552001953125 C -1366.548828125 -896.4029541015625 -1366.642822265625 -897.0460205078125 -1366.380615234375 -897.5904541015625 C -1366.146850585938 -898.0756225585938 -1365.676025390625 -898.4103393554688 -1365.14794921875 -898.4103393554688 Z"
                  stroke="none"
                />
              </g>
              <g
                id="Path_28630"
                data-name="Path 28630"
                transform="translate(1388.564 750.924)"
              >
                <path
                  d="M -1382.793090820312 -727.35595703125 C -1383.092895507812 -727.35595703125 -1383.362426757812 -727.4711303710938 -1383.59423828125 -727.6983032226562 C -1385.08740234375 -729.1611938476562 -1386.59033203125 -730.6624755859375 -1388.061401367188 -732.160400390625 C -1388.5390625 -732.6472778320312 -1388.5283203125 -733.4183349609375 -1388.036865234375 -733.9158325195312 C -1386.564086914062 -735.4065551757812 -1385.085571289062 -736.8844604492188 -1383.642700195312 -738.3085327148438 C -1383.3984375 -738.549560546875 -1383.080444335938 -738.6823120117188 -1382.747436523438 -738.6823120117188 C -1382.408447265625 -738.6823120117188 -1382.083740234375 -738.5470581054688 -1381.8330078125 -738.301513671875 C -1381.32421875 -737.8028564453125 -1381.3056640625 -737.0075073242188 -1381.790771484375 -736.4908447265625 C -1382.137451171875 -736.1213989257812 -1382.507080078125 -735.759521484375 -1382.864501953125 -735.4094848632812 C -1383.0341796875 -735.2432861328125 -1383.203857421875 -735.0770874023438 -1383.3720703125 -734.909423828125 C -1383.428955078125 -734.8525390625 -1383.483520507812 -734.7938842773438 -1383.552490234375 -734.7196044921875 C -1383.590209960938 -734.67919921875 -1383.632690429688 -734.6334838867188 -1383.682861328125 -734.5801391601562 L -1383.921142578125 -734.3272705078125 L -1383.57373046875 -734.3272705078125 L -1383.110107421875 -734.3272705078125 L -1380.0263671875 -734.3273315429688 L -1377.638793945312 -734.3273315429688 C -1373.371337890625 -734.3273315429688 -1370.28662109375 -734.3268432617188 -1365.269897460938 -734.3238525390625 C -1365.069580078125 -734.3236694335938 -1364.809936523438 -734.3142700195312 -1364.578369140625 -734.242431640625 C -1363.97998046875 -734.05712890625 -1363.6279296875 -733.4658813476562 -1363.722290039062 -732.8047485351562 C -1363.803833007812 -732.2315673828125 -1364.315063476562 -731.7684326171875 -1364.911376953125 -731.7274169921875 C -1364.966064453125 -731.7236328125 -1365.025268554688 -731.721923828125 -1365.103271484375 -731.721923828125 C -1365.137084960938 -731.721923828125 -1365.170776367188 -731.7222290039062 -1365.20458984375 -731.7225341796875 C -1365.2392578125 -731.7228393554688 -1365.27392578125 -731.72314453125 -1365.30859375 -731.72314453125 L -1383.114990234375 -731.7230224609375 L -1383.564208984375 -731.7230224609375 L -1383.92333984375 -731.7230224609375 L -1383.6708984375 -731.4675903320312 C -1383.4833984375 -731.27783203125 -1383.300048828125 -731.092041015625 -1383.11962890625 -730.9090576171875 C -1382.689331054688 -730.472900390625 -1382.282958984375 -730.0609130859375 -1381.8701171875 -729.6470947265625 C -1381.603271484375 -729.3797607421875 -1381.464721679688 -729.0888671875 -1381.446411132812 -728.7577514648438 C -1381.416259765625 -728.2105712890625 -1381.705688476562 -727.716796875 -1382.183837890625 -727.499755859375 C -1382.39404296875 -727.4043579101562 -1382.598999023438 -727.35595703125 -1382.793090820312 -727.35595703125 Z"
                  stroke="none"
                />
                <path
                  d="M -1382.793090820312 -727.5059814453125 C -1382.620483398438 -727.5059814453125 -1382.436401367188 -727.5498046875 -1382.245849609375 -727.6363525390625 C -1381.824462890625 -727.82763671875 -1381.569458007812 -728.2645874023438 -1381.59619140625 -728.7494506835938 C -1381.612548828125 -729.0462036132812 -1381.733276367188 -729.2977294921875 -1381.976318359375 -729.5411376953125 C -1382.389526367188 -729.9552612304688 -1382.796020507812 -730.367431640625 -1383.226440429688 -730.8037109375 C -1383.406860351562 -730.9866333007812 -1383.590087890625 -731.1724243164062 -1383.777587890625 -731.3621215820312 L -1384.282470703125 -731.8729858398438 L -1365.30859375 -731.8731079101562 C -1365.240112304688 -731.8731079101562 -1365.171752929688 -731.8718872070312 -1365.103271484375 -731.8718872070312 C -1365.028930664062 -731.8718872070312 -1364.972900390625 -731.8734741210938 -1364.921752929688 -731.8770751953125 C -1364.403076171875 -731.9127197265625 -1363.94140625 -732.3295288085938 -1363.870727539062 -732.825927734375 C -1363.787109375 -733.4125366210938 -1364.096313476562 -733.9360961914062 -1364.622680664062 -734.0991821289062 C -1364.835205078125 -734.1650390625 -1365.080322265625 -734.1737060546875 -1365.269897460938 -734.1738891601562 C -1370.292114257812 -734.1768188476562 -1373.375610351562 -734.1773681640625 -1377.638793945312 -734.1773681640625 L -1384.268432617188 -734.1773071289062 L -1383.792114257812 -734.6829833984375 C -1383.742065429688 -734.736083984375 -1383.699829101562 -734.7815551757812 -1383.662353515625 -734.82177734375 C -1383.59228515625 -734.8971557617188 -1383.536987304688 -734.9566650390625 -1383.477905273438 -735.015625 C -1383.309448242188 -735.1836547851562 -1383.139404296875 -735.3501586914062 -1382.969482421875 -735.5166625976562 C -1382.613159179688 -735.8656005859375 -1382.244750976562 -736.2263793945312 -1381.900146484375 -736.593505859375 C -1381.471313476562 -737.0501708984375 -1381.488037109375 -737.7533569335938 -1381.93798828125 -738.1943969726562 C -1382.160400390625 -738.4122924804688 -1382.447998046875 -738.5323486328125 -1382.747436523438 -738.5323486328125 C -1383.040771484375 -738.5323486328125 -1383.3212890625 -738.4149169921875 -1383.537353515625 -738.2017822265625 C -1384.979858398438 -736.7781372070312 -1386.457763671875 -735.3006591796875 -1387.93017578125 -733.8104248046875 C -1388.363403320312 -733.371826171875 -1388.3740234375 -732.6931762695312 -1387.954345703125 -732.2655029296875 C -1386.484008789062 -730.7682495117188 -1384.981811523438 -729.2677001953125 -1383.4892578125 -727.8054809570312 C -1383.286499023438 -727.606689453125 -1383.05224609375 -727.5059204101562 -1382.793090820312 -727.5059814453125 L -1382.793090820312 -727.5059814453125 M -1382.793090820312 -727.2059326171875 C -1383.121337890625 -727.2059326171875 -1383.431274414062 -727.32861328125 -1383.69921875 -727.5911865234375 C -1385.203369140625 -729.0648193359375 -1386.693115234375 -730.552978515625 -1388.16845703125 -732.0552978515625 C -1388.7099609375 -732.6072998046875 -1388.689697265625 -733.4683837890625 -1388.1435546875 -734.021240234375 C -1386.6875 -735.4949951171875 -1385.222412109375 -736.960205078125 -1383.748046875 -738.415283203125 C -1383.173217773438 -738.9825439453125 -1382.29296875 -738.9620361328125 -1381.72802734375 -738.40869140625 C -1381.16845703125 -737.8602294921875 -1381.133056640625 -736.97216796875 -1381.681396484375 -736.38818359375 C -1382.1923828125 -735.84375 -1382.737060546875 -735.330810546875 -1383.26611328125 -734.80322265625 C -1383.35107421875 -734.71826171875 -1383.43115234375 -734.628662109375 -1383.57373046875 -734.477294921875 L -1383.110107421875 -734.477294921875 C -1375.830078125 -734.4772338867188 -1372.5498046875 -734.4781494140625 -1365.269775390625 -734.473876953125 C -1365.02392578125 -734.4736328125 -1364.766357421875 -734.457763671875 -1364.533935546875 -734.3857421875 C -1363.85888671875 -734.1766357421875 -1363.470703125 -733.505859375 -1363.57373046875 -732.7835693359375 C -1363.664794921875 -732.14404296875 -1364.23583984375 -731.62353515625 -1364.901123046875 -731.5777587890625 C -1365.0361328125 -731.5684204101562 -1365.17236328125 -731.5730590820312 -1365.30859375 -731.5731201171875 C -1372.577392578125 -731.572998046875 -1375.84619140625 -731.572998046875 -1383.114990234375 -731.572998046875 L -1383.564208984375 -731.572998046875 C -1382.93408203125 -730.9354248046875 -1382.351318359375 -730.341796875 -1381.763916015625 -729.7530517578125 C -1381.4892578125 -729.4779052734375 -1381.318359375 -729.15966796875 -1381.296630859375 -728.7659912109375 C -1381.263427734375 -728.16357421875 -1381.578125 -727.6099853515625 -1382.121826171875 -727.3631591796875 C -1382.348999023438 -727.2600708007812 -1382.575073242188 -727.2059936523438 -1382.793090820312 -727.2059326171875 Z"
                  stroke="none"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }

    // routes
    case "masterSchedule": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g
              id="masterschedule"
              transform="translate(-41 -53)"
            // clip-path="url(#clip-path)"
            >
              <path
                id="calendar-clock_2_"
                dataName="calendar-clock (2)"
                d="M145.833,91.992A54,54,0,1,0,200,145.833,54.229,54.229,0,0,0,145.833,91.992Zm0,99.675a45.671,45.671,0,1,1,45.833-45.833A45.728,45.728,0,0,1,145.833,191.667Zm11.283-40.45a4.169,4.169,0,0,1-5.9,5.892l-8.333-8.333a4.161,4.161,0,0,1-1.217-2.95V129.158a4.167,4.167,0,0,1,8.333,0V144.1ZM162.5,16.667H150V4.167a4.167,4.167,0,0,0-8.333,0v12.5H58.333V4.167a4.167,4.167,0,1,0-8.333,0v12.5H37.5A37.546,37.546,0,0,0,0,54.167V162.5A37.546,37.546,0,0,0,37.5,200h50a4.167,4.167,0,0,0,0-8.333h-50A29.2,29.2,0,0,1,8.333,162.5V75H191.667V87.5a4.167,4.167,0,0,0,8.333,0V54.167A37.546,37.546,0,0,0,162.5,16.667Zm-154.167,50v-12.5A29.2,29.2,0,0,1,37.5,25h125a29.2,29.2,0,0,1,29.167,29.167v12.5Z"
                transform="translate(41 53)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "orderDashboard": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g
              id="Dashboard"
              transform="translate(-41 -537)"
            // clip-path="url(#clip-path)"
            >
              <g id="analytics_238057" transform="translate(41 537)">
                <g id="Group_26" dataName="Group 26">
                  <g id="Group_25" dataName="Group 25">
                    <path
                      id="Path_13"
                      dataName="Path 13"
                      d="M126.667,173.333H73.333A16.5,16.5,0,0,0,56.666,190,3.149,3.149,0,0,0,60,193.333h80A3.149,3.149,0,0,0,143.333,190,16.5,16.5,0,0,0,126.667,173.333ZM64,186.667A9.71,9.71,0,0,1,73.333,180H127a9.71,9.71,0,0,1,9.333,6.667Z"
                    />
                  </g>
                </g>
                <g id="Group_28" dataName="Group 28">
                  <g id="Group_27" dataName="Group 27">
                    <path
                      id="Path_14"
                      dataName="Path 14"
                      d="M126.667,176,120,149.333a3.246,3.246,0,0,0-3.333-2.667H83.334A3.588,3.588,0,0,0,80,149.333L73.334,176A3.591,3.591,0,0,0,74,178.667,3.032,3.032,0,0,0,76.667,180h46.667A3.785,3.785,0,0,0,126,179,3.4,3.4,0,0,0,126.667,176ZM81,173.333l5-20h28l5,20Z"
                    />
                  </g>
                </g>
                <g id="Group_30" dataName="Group 30">
                  <g id="Group_29" dataName="Group 29">
                    <path
                      id="Path_15"
                      dataName="Path 15"
                      d="M185,6.667H15a14.938,14.938,0,0,0-15,15V123.334a3.149,3.149,0,0,0,3.333,3.333H196.666A3.149,3.149,0,0,0,200,123.334V21.667A14.937,14.937,0,0,0,185,6.667ZM193.333,120H6.667V21.667A8.252,8.252,0,0,1,15,13.334H185a8.252,8.252,0,0,1,8.333,8.333Z"
                    />
                  </g>
                </g>
                <g id="Group_32" dataName="Group 32">
                  <g id="Group_31" dataName="Group 31">
                    <path
                      id="Path_16"
                      dataName="Path 16"
                      d="M196.667,120H3.333A3.149,3.149,0,0,0,0,123.333v15a14.938,14.938,0,0,0,15,15H185a14.938,14.938,0,0,0,15-15v-15A3.149,3.149,0,0,0,196.667,120Zm-3.334,18.333A8.252,8.252,0,0,1,185,146.666H15a8.252,8.252,0,0,1-8.333-8.333V126.666H193.334v11.667Z"
                    />
                  </g>
                </g>
                <g id="Group_34" dataName="Group 34">
                  <g id="Group_33" dataName="Group 33">
                    <path
                      id="Path_17"
                      dataName="Path 17"
                      d="M113.333,96.667A3.149,3.149,0,0,0,110,100v10a3.333,3.333,0,0,0,6.666,0V100A3.149,3.149,0,0,0,113.333,96.667Z"
                    />
                  </g>
                </g>
                <g id="Group_36" dataName="Group 36">
                  <g id="Group_35" dataName="Group 35">
                    <path
                      id="Path_18"
                      dataName="Path 18"
                      d="M126.667,83.333a3.149,3.149,0,0,0-3.333,3.333V110A3.333,3.333,0,0,0,130,110V86.667A3.149,3.149,0,0,0,126.667,83.333Z"
                    />
                  </g>
                </g>
                <g id="Group_38" dataName="Group 38">
                  <g id="Group_37" dataName="Group 37">
                    <path
                      id="Path_19"
                      dataName="Path 19"
                      d="M140,90a3.149,3.149,0,0,0-3.333,3.333V110a3.333,3.333,0,1,0,6.666,0V93.333A3.149,3.149,0,0,0,140,90Z"
                    />
                  </g>
                </g>
                <g id="Group_40" dataName="Group 40">
                  <g id="Group_39" dataName="Group 39">
                    <path
                      id="Path_20"
                      dataName="Path 20"
                      d="M153.333,66.667A3.149,3.149,0,0,0,150,70v40a3.333,3.333,0,1,0,6.666,0V70A3.149,3.149,0,0,0,153.333,66.667Z"
                    />
                  </g>
                </g>
                <g id="Group_42" dataName="Group 42">
                  <g id="Group_41" dataName="Group 41">
                    <path
                      id="Path_21"
                      dataName="Path 21"
                      d="M166.667,80a3.149,3.149,0,0,0-3.333,3.333V110A3.333,3.333,0,0,0,170,110V83.333A3.149,3.149,0,0,0,166.667,80Z"
                    />
                  </g>
                </g>
                <g id="Group_44" dataName="Group 44">
                  <g id="Group_43" dataName="Group 43">
                    <path
                      id="Path_22"
                      dataName="Path 22"
                      d="M58.333,26.667A38.333,38.333,0,1,0,96.666,65,38.554,38.554,0,0,0,58.333,26.667Zm0,70A31.667,31.667,0,1,1,90,65,31.868,31.868,0,0,1,58.333,96.667Z"
                    />
                  </g>
                </g>
                <g id="Group_46" dataName="Group 46">
                  <g id="Group_45" dataName="Group 45">
                    <path
                      id="Path_23"
                      dataName="Path 23"
                      d="M85.667,38a39.425,39.425,0,0,0-29-11.333A3.418,3.418,0,0,0,53.334,30V66.667A3.34,3.34,0,0,0,56.667,70H93.334A10.294,10.294,0,0,0,96,69.333,3.026,3.026,0,0,0,97,67,38.923,38.923,0,0,0,85.667,38ZM60,63.333v-30a30.539,30.539,0,0,1,20.667,9.333A30.537,30.537,0,0,1,90,63.333Z"
                    />
                  </g>
                </g>
                <g id="Group_48" dataName="Group 48">
                  <g id="Group_47" dataName="Group 47">
                    <path
                      id="Path_24"
                      dataName="Path 24"
                      d="M83.667,89,59,64.333A3.3,3.3,0,0,0,54.333,69L79,93.667a3.222,3.222,0,0,0,4.666,0A3.222,3.222,0,0,0,83.667,89Z"
                    />
                  </g>
                </g>
                <g id="Group_50" dataName="Group 50">
                  <g id="Group_49" dataName="Group 49">
                    <path
                      id="Path_25"
                      dataName="Path 25"
                      d="M150,40H123.333a3.333,3.333,0,0,0,0,6.666H150A3.333,3.333,0,1,0,150,40Z"
                    />
                  </g>
                </g>
                <g id="Group_52" dataName="Group 52">
                  <g id="Group_51" dataName="Group 51">
                    <path
                      id="Path_26"
                      dataName="Path 26"
                      d="M169.333,41c-.333,0-.333-.333-.667-.333s-.333-.333-.667-.333c-.333-.333-.333-.333-.667-.333a4.653,4.653,0,0,0-3,1,3.026,3.026,0,0,0-1,2.333c0,.667.333,1,.333,1.333s.333.667.667,1a3.026,3.026,0,0,0,2.333,1h.667c.333-.333.333-.333.667-.333a32814165563729.8,32814165563729.8,0,0,1,1.334-.666c.333-.333.333-.667.667-1a2,2,0,0,0,.333-1.333A3.026,3.026,0,0,0,169.333,41Z"
                    />
                  </g>
                </g>
                <g id="Group_54" dataName="Group 54">
                  <g id="Group_53" dataName="Group 53">
                    <path
                      id="Path_27"
                      dataName="Path 27"
                      d="M166.667,23.333h-10a3.149,3.149,0,0,0-3.333,3.333A3.149,3.149,0,0,0,156.667,30h10A3.149,3.149,0,0,0,170,26.666,3.149,3.149,0,0,0,166.667,23.333Z"
                    />
                  </g>
                </g>
                <g id="Group_56" dataName="Group 56">
                  <g id="Group_55" dataName="Group 55">
                    <path
                      id="Path_28"
                      dataName="Path 28"
                      d="M130,23.333h-6.667A3.149,3.149,0,0,0,120,26.666,3.149,3.149,0,0,0,123.333,30H130a3.149,3.149,0,0,0,3.333-3.333A3.149,3.149,0,0,0,130,23.333Z"
                    />
                  </g>
                </g>
                <g id="Group_58" dataName="Group 58">
                  <g id="Group_57" dataName="Group 57">
                    <path
                      id="Path_29"
                      dataName="Path 29"
                      d="M146,24.333c-.333,0-.333-.333-.667-.333s-.333-.333-.667-.333c-.333-.333-.333-.333-.667-.333h-1.333c-.333.333-.333.333-.667.333s-.333.333-.667.333l-.333.333c-.333.333-.667.667-.667,1A2,2,0,0,0,140,26.666,3.025,3.025,0,0,0,141,29l.333.333c.333,0,.333.333.667.333.333.333.333.333.667.333h1c.333-.333.333-.333.667-.333a1.163,1.163,0,0,0,.667-.333,1.165,1.165,0,0,0,.667-.333,3.026,3.026,0,0,0,1-2.333V25.333C146.667,25,146.333,24.667,146,24.333Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "notes": {
      return (
        <svg
          id="Group_39275"
          data-name="Group 39275"
          xmlns="http://www.w3.org/2000/svg"
          width="16.487"
          height="16.519"
          viewBox="0 0 16.487 16.519"
        >
          <path
            id="Path_28634"
            data-name="Path 28634"
            d="M-2116.943-1076.481h-9.982a3.1,3.1,0,0,1-.455-.147,1.44,1.44,0,0,1-.833-1.394q0-4.323,0-8.646,0-2.4,0-4.791a1.41,1.41,0,0,1,.6-1.251,3.724,3.724,0,0,1,.686-.291h8.147a1.951,1.951,0,0,1,1.066.613c.5.489,1.005.969,1.516,1.444a1.644,1.644,0,0,1,.543,1.275c-.007,1.462,0,2.924,0,4.386v.2c.062-.07.094-.106.125-.142.405-.48.807-.963,1.216-1.44a1.435,1.435,0,0,1,2.389.178,3.164,3.164,0,0,1,.2.519v.387a2.073,2.073,0,0,1-.447.875q-1.7,2-3.38,4.014a.46.46,0,0,0-.1.27c-.007.805,0,1.611,0,2.417a1.4,1.4,0,0,1-.6,1.233A3.769,3.769,0,0,1-2116.943-1076.481Zm-2.576-15.545c-.045,0-.076-.006-.107-.006q-3.55,0-7.1,0a.486.486,0,0,0-.521.542q0,6.75,0,13.5a.489.489,0,0,0,.539.54h9.546a.49.49,0,0,0,.54-.539c0-.441,0-.882,0-1.323,0-.04,0-.079-.008-.122-.144.079-.27.161-.405.221-.553.245-1.11.483-1.665.726a.5.5,0,0,1-.571-.058.508.508,0,0,1-.135-.547q.207-.861.409-1.723a1.73,1.73,0,0,1,.371-.741q.954-1.124,1.9-2.256a.459.459,0,0,0,.1-.269c.006-1.624,0-3.247,0-4.871v-.177h-2.324a.5.5,0,0,1-.574-.57q0-1.073,0-2.145Zm5.042,7.054-2.669,3.164.739.622,2.667-3.166Zm-2.252-5.131-1.815-1.736v1.736Zm2.875,4.39.738.621c.11-.132.219-.25.314-.377a.474.474,0,0,0-.072-.675.471.471,0,0,0-.662.06C-2113.641-1085.971-2113.738-1085.849-2113.854-1085.713Zm-3.183,5.262-.728-.613c-.395.357-.33.868-.474,1.312C-2117.835-1079.981-2117.321-1080-2117.037-1080.451Z"
            transform="translate(2128.214 1093)"
            fill={color || "#4b96cd"}
          />
          <path
            id="Path_28635"
            data-name="Path 28635"
            d="M-2075.938-947.25q-1.908,0-3.815,0a.483.483,0,0,1-.5-.641.468.468,0,0,1,.421-.324,1.468,1.468,0,0,1,.161,0h7.47c.386,0,.611.178.611.484s-.225.484-.611.484Z"
            transform="translate(2082.218 954.057)"
            fill={color || "#4b96cd"}
          />
          <path
            id="Path_28636"
            data-name="Path 28636"
            d="M-2075.97-875.232q-1.9,0-3.8,0a.484.484,0,0,1-.5-.654.472.472,0,0,1,.4-.309.776.776,0,0,1,.113,0h7.6a.749.749,0,0,1,.191.02.478.478,0,0,1,.357.493.486.486,0,0,1-.43.45,1.568,1.568,0,0,1-.177,0Z"
            transform="translate(2082.236 884.944)"
            fill={color || "#4b96cd"}
          />
          <path
            id="Path_28637"
            data-name="Path 28637"
            d="M-2077.385-1021.017c.789,0,1.578,0,2.367,0a.483.483,0,0,1,.481.656.48.48,0,0,1-.465.31c-.365,0-.73,0-1.095,0q-1.835,0-3.67,0a.485.485,0,0,1-.5-.656.492.492,0,0,1,.5-.31Q-2078.576-1021.019-2077.385-1021.017Z"
            transform="translate(2082.231 1023.921)"
            fill={color || "#4b96cd"}
          />
          <path
            id="Path_28638"
            data-name="Path 28638"
            d="M-2077.4-803.254c-.789,0-1.578,0-2.366,0a.483.483,0,0,1-.486-.652.482.482,0,0,1,.462-.313c.225,0,.451,0,.676,0q2.045,0,4.089,0a.486.486,0,0,1,.5.653.49.49,0,0,1-.495.314Q-2076.211-803.252-2077.4-803.254Z"
            transform="translate(2082.22 815.869)"
            fill={color || "#4b96cd"}
          />
        </svg>
      );
    }
    case "agent": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g
              id="Agent"
              transform="translate(-268 -53)"
            // clip-path="url(#clip-path)"
            >
              <path
                id="boss"
                d="M100,83.333A41.667,41.667,0,1,0,58.333,41.667,41.714,41.714,0,0,0,100,83.333Zm0-75A33.333,33.333,0,1,1,66.667,41.667,33.367,33.367,0,0,1,100,8.333ZM200,166.667H166.667v-37.5a37.546,37.546,0,0,0-37.5-37.5H70.833a37.546,37.546,0,0,0-37.5,37.5v37.5H0V175H16.667v25H25V175H175v25h8.333V175H200Zm-41.667-37.5v37.5H119.917L108.65,121.608,123.058,100h6.1a29.2,29.2,0,0,1,29.167,29.167ZM100,119.575,86.95,100h26.1Zm0,1.767,11.333,45.325H88.667L100,121.342Zm-58.333,7.825A29.2,29.2,0,0,1,70.833,100h6.1l14.408,21.608L80.075,166.667H41.658v-37.5Z"
                transform="translate(268 53)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "accounting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g
              id="Accounting"
              transform="translate(-41 -537)"
            // clip-path="url(#clip-path)"
            >
              <g id="calculator_548606" transform="translate(41 537)">
                <g id="Group_14" dataName="Group 14">
                  <g id="Group_13" dataName="Group 13">
                    <path
                      id="Path_7"
                      dataName="Path 7"
                      d="M195.775,39.434a4.225,4.225,0,0,0-4.225,4.225V95.775H104.225V8.451h74.648A12.691,12.691,0,0,1,191.55,21.127a4.225,4.225,0,1,0,8.45,0A21.151,21.151,0,0,0,178.873,0H21.127A21.151,21.151,0,0,0,0,21.127V178.873A21.151,21.151,0,0,0,21.127,200H178.873A21.151,21.151,0,0,0,200,178.873V43.66A4.225,4.225,0,0,0,195.775,39.434ZM8.451,21.127A12.691,12.691,0,0,1,21.127,8.451H95.775V95.775H8.451Zm183.1,157.746a12.691,12.691,0,0,1-12.676,12.676H21.127A12.691,12.691,0,0,1,8.451,178.873V104.225H95.775v69.014a4.225,4.225,0,1,0,8.451,0V104.225h87.324v74.648Z"
                    />
                  </g>
                </g>
                <g id="Group_16" dataName="Group 16">
                  <g id="Group_15" dataName="Group 15">
                    <path
                      id="Path_8"
                      dataName="Path 8"
                      d="M71.831,47.888H56.338V32.395a4.225,4.225,0,1,0-8.451,0V47.887H32.395a4.225,4.225,0,0,0,0,8.451H47.887V71.831a4.225,4.225,0,0,0,8.451,0V56.338H71.831a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_18" dataName="Group 18">
                  <g id="Group_17" dataName="Group 17">
                    <path
                      id="Path_9"
                      dataName="Path 9"
                      d="M167.605,132.395H128.169a4.225,4.225,0,1,0,0,8.451h39.436a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_20" dataName="Group 20">
                  <g id="Group_19" dataName="Group 19">
                    <path
                      id="Path_10"
                      dataName="Path 10"
                      d="M167.605,154.93H128.169a4.225,4.225,0,1,0,0,8.451h39.436a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_22" dataName="Group 22">
                  <g id="Group_21" dataName="Group 21">
                    <path
                      id="Path_11"
                      dataName="Path 11"
                      d="M58.088,147.887l10.955-10.955a4.226,4.226,0,0,0-5.975-5.976L52.112,141.912,41.157,130.956a4.225,4.225,0,0,0-5.975,5.976l10.954,10.955L35.181,158.843a4.225,4.225,0,0,0,5.975,5.976l10.955-10.955,10.955,10.955a4.225,4.225,0,1,0,5.975-5.976Z"
                    />
                  </g>
                </g>
                <g id="Group_24" dataName="Group 24">
                  <g id="Group_23" dataName="Group 23">
                    <path
                      id="Path_12"
                      dataName="Path 12"
                      d="M167.605,47.888H128.169a4.225,4.225,0,0,0,0,8.451h39.436a4.225,4.225,0,0,0,0-8.451Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "clientManagement": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g
              id="Client"
              transform="translate(-495 -53)"
            // clip-path="url(#clip-path)"
            >
              <path
                id="customer-care"
                d="M33.333,33.333A16.667,16.667,0,1,0,16.667,16.667,16.683,16.683,0,0,0,33.333,33.333Zm0-25A8.333,8.333,0,1,1,25,16.667,8.342,8.342,0,0,1,33.333,8.333ZM75,41.667A16.667,16.667,0,1,0,58.333,25,16.683,16.683,0,0,0,75,41.667Zm0-25A8.333,8.333,0,1,1,66.667,25,8.342,8.342,0,0,1,75,16.667Zm41.667,16.667A16.667,16.667,0,1,0,100,16.667,16.683,16.683,0,0,0,116.667,33.333Zm0-25a8.333,8.333,0,1,1-8.333,8.333A8.342,8.342,0,0,1,116.667,8.333Zm-66.15,61.65a25.515,25.515,0,0,1,49.817,0c.475,2.25-.575,5.017-4.083,5.017a4.163,4.163,0,0,1-4.067-3.317,17.193,17.193,0,0,0-33.517,0,4.166,4.166,0,0,1-8.158-1.692Zm66.15-28.317A25.391,25.391,0,0,1,141.575,61.65a4.06,4.06,0,0,1-4.083,5.017,4.223,4.223,0,0,1-4.067-3.317A17.038,17.038,0,0,0,116.667,50a17.371,17.371,0,0,0-6.733,1.342,4.165,4.165,0,1,1-3.2-7.692,25.619,25.619,0,0,1,9.933-1.983ZM8.425,61.65a25.585,25.585,0,0,1,34.842-18,4.165,4.165,0,1,1-3.2,7.692A17.493,17.493,0,0,0,33.333,50,17.037,17.037,0,0,0,16.575,63.35c-.408,1.967-2.158,3.592-4.067,3.317C9.133,66.183,7.95,63.908,8.425,61.65Zm184.75,18.8A21.157,21.157,0,0,0,178.1,75.017a20.8,20.8,0,0,0-14.492,6.817l-31.1,34.183A22.057,22.057,0,0,0,111.317,100H29.167A29.2,29.2,0,0,0,0,129.167v41.667A29.2,29.2,0,0,0,29.167,200H78.875a79.221,79.221,0,0,0,59.108-26.508L194.7,109.833a20.992,20.992,0,0,0-1.525-29.383Zm-4.692,23.842L131.767,167.95a70.892,70.892,0,0,1-52.892,23.717H29.167A20.857,20.857,0,0,1,8.333,170.833V129.167a20.857,20.857,0,0,1,20.833-20.833h82.142a13.684,13.684,0,0,1,2.042,27.217l-51.342,6.142A4.167,4.167,0,1,0,63,149.967l51.442-6.158a22.149,22.149,0,0,0,17.875-15.2l37.467-41.167a12.577,12.577,0,0,1,17.783-.825,12.635,12.635,0,0,1,.917,17.683Z"
                transform="translate(495.012 53)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "company": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_7"
                  dataName="Rectangle 7"
                  width="200"
                  height="200"
                  transform="translate(495 295)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs>
            <g
              id="Company"
              transform="translate(-495 -295)"
              clip-path="url(#clip-path)"
            >
              <path
                id="city"
                d="M133.333,112.5a4.168,4.168,0,0,1-4.167,4.167h-8.333a4.167,4.167,0,0,1,0-8.333h8.333A4.168,4.168,0,0,1,133.333,112.5Zm29.167-4.167h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333Zm-33.333,33.333h-8.333a4.167,4.167,0,0,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333Zm33.333,0h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333Zm-33.333-100h-8.333a4.167,4.167,0,0,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333Zm33.333,0h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333ZM129.167,75h-8.333a4.167,4.167,0,1,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333ZM162.5,75h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333ZM200,37.5v125A37.546,37.546,0,0,1,162.5,200H37.5A37.546,37.546,0,0,1,0,162.5V73.767A37.688,37.688,0,0,1,11.483,46.758L25.6,33.167a29.052,29.052,0,0,1,40.458,0L80.175,46.758a36.2,36.2,0,0,1,3.15,3.45v-12.7a37.546,37.546,0,0,1,37.5-37.5h41.667a37.546,37.546,0,0,1,37.5,37.5ZM83.333,73.767A29.32,29.32,0,0,0,74.4,52.758L60.283,39.167a20.75,20.75,0,0,0-28.9,0l-14.117,13.6A29.32,29.32,0,0,0,8.333,73.775v88.733A29.2,29.2,0,0,0,37.5,191.675H83.333V73.767ZM191.667,37.5A29.2,29.2,0,0,0,162.5,8.333H120.833A29.2,29.2,0,0,0,91.667,37.5V191.667H162.5A29.2,29.2,0,0,0,191.667,162.5Zm-137.5,70.833H37.5a4.167,4.167,0,1,0,0,8.333H54.167a4.167,4.167,0,1,0,0-8.333Zm0-33.333H37.5a4.167,4.167,0,1,0,0,8.333H54.167a4.167,4.167,0,1,0,0-8.333Zm0,66.667H37.5a4.167,4.167,0,0,0,0,8.333H54.167a4.167,4.167,0,0,0,0-8.333Z"
                transform="translate(495 294.996)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "subscription": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_8"
                  dataName="Rectangle 8"
                  width="200"
                  height="200"
                  transform="translate(714 295)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Subscription_"
              dataName="Subscription "
              transform="translate(-714 -295)"
            // clip-path="url(#clip-path)"
            >
              <path
                id="subscription-alt"
                d="M199.992,37.5V54.164a37.544,37.544,0,0,1-37.5,37.5H129.161a4.166,4.166,0,1,1,0-8.333h33.332a29.2,29.2,0,0,0,29.165-29.165V37.5A29.2,29.2,0,0,0,162.493,8.333H37.5A29.2,29.2,0,0,0,8.333,37.5V54.164A29.2,29.2,0,0,0,37.5,83.33h8.333a4.166,4.166,0,1,1,0,8.333H37.5A37.544,37.544,0,0,1,0,54.164V37.5A37.544,37.544,0,0,1,37.5,0H162.493A37.544,37.544,0,0,1,199.992,37.5ZM147.96,157.8l-39.632-14.858V105.062c0-10.608-7.466-19.824-17.366-21.441A21.042,21.042,0,0,0,74.005,88.3a20.8,20.8,0,0,0-7.341,15.874v61.864l-1.15.558L51.581,155.51a20.831,20.831,0,0,0-28.415,30.465l13.666,12.9a4.138,4.138,0,0,0,5.691-6.008L28.915,179.942a12.5,12.5,0,0,1,17-18.341c.108.108,14.416,11.508,14.416,11.508A9.041,9.041,0,0,0,75,166.026V104.162A12.5,12.5,0,0,1,89.63,91.838C95.538,92.8,100,98.479,100,105.054v40.773a4.165,4.165,0,0,0,2.7,3.9L145.027,165.6c13.349,5.008,21.632,16.583,21.632,30.224a4.166,4.166,0,1,0,8.333,0c0-17.2-10.358-31.765-27.032-38.023Z"
                transform="translate(714.004 295)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "consoleIcon": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            data-name="Layer 1"
            viewBox="0 0 512 512"
          >
            <path d="M500.051,475.475l-44.9-77.779a12.018,12.018,0,0,0-14.863-5.165l-10.5-18.194a102.893,102.893,0,0,0-58.966-181.648V91.9a7,7,0,0,0-2.052-4.952L283.842,2.05A7,7,0,0,0,278.892,0H77.857A24.25,24.25,0,0,0,53.619,24.208V38.749H34.543a24.237,24.237,0,0,0-24.209,24.21v383.56a24.25,24.25,0,0,0,24.209,24.236H303.27a24.264,24.264,0,0,0,24.237-24.236V432.005h19.076a24.265,24.265,0,0,0,24.238-24.237v-9.681a102.28,102.28,0,0,0,23.428-4.351l10.994,19.033a11.991,11.991,0,0,0-2.955,15.422l44.9,77.783a11.949,11.949,0,0,0,7.335,5.616,12.122,12.122,0,0,0,3.115.41,11.828,11.828,0,0,0,5.975-1.618l32.06-18.5A12.033,12.033,0,0,0,500.051,475.475Zm-47.309-180.1a88.938,88.938,0,1,1-88.923-88.923A89.038,89.038,0,0,1,452.742,295.373ZM285.894,23.9l61.017,61H285.894ZM313.5,446.519a10.244,10.244,0,0,1-10.233,10.232H34.543a10.229,10.229,0,0,1-10.2-10.232V62.959a10.216,10.216,0,0,1,10.2-10.205H53.619V407.768a24.265,24.265,0,0,0,24.238,24.237H313.5ZM346.583,418H77.857a10.245,10.245,0,0,1-10.234-10.233V24.208A10.23,10.23,0,0,1,77.857,14H271.89V91.9a7,7,0,0,0,7,7h77.925v93.787a102.936,102.936,0,0,0,0,205.4v9.681A10.245,10.245,0,0,1,346.583,418Zm71.818-35.38,9.691,16.789L417.3,405.644l-9.843-17.039A102.74,102.74,0,0,0,418.4,382.621Zm39.928,114.643-42.922-74.357,25.554-14.758c.067-.036.136-.062.2-.1.087-.05.165-.108.249-.162l2.591-1.5,42.93,74.367ZM257.518,372.958h-9.212V252.6a7,7,0,0,0-7-7H207.656a7,7,0,0,0-7,7v21.713H181.04V252.6a7,7,0,0,0-7-7h-33.62a7,7,0,0,0-7,7v50.994H106.8a7,7,0,0,0-7,7v62.363h-9.24a7,7,0,0,0,0,14H257.518a7,7,0,1,0,0-14ZM214.658,259.6H234.3V372.958H214.658Zm-14,28.715v84.642H181.04V288.316ZM147.42,259.6h19.615V372.958H147.42Zm-33.619,58h19.615v55.361H113.8ZM92.823,73.532a7,7,0,0,1,7-7H224.749a7,7,0,1,1,0,14H99.825A7,7,0,0,1,92.823,73.532Zm0,42.151a7,7,0,0,1,7-7H224.749a7,7,0,1,1,0,14H99.825A7,7,0,0,1,92.823,115.683Zm192.446,179.69a78.535,78.535,0,1,0,78.55-78.549A78.639,78.639,0,0,0,285.269,295.373Zm143.066,0a64.531,64.531,0,1,1-64.516-64.545A64.6,64.6,0,0,1,428.335,295.373ZM96.346,235.736a20.631,20.631,0,0,0,18.371-25.99l17.719-12.2a20.464,20.464,0,0,0,12.569,4.336c.569,0,1.142-.023,1.716-.07a20.646,20.646,0,0,0,8.667-2.686l13.662,11.641A20.727,20.727,0,0,0,188.4,238.838c.552,0,1.106-.023,1.663-.066a20.767,20.767,0,0,0,17.63-28.4l35.777-31.759a20.477,20.477,0,0,0,9.869,2.541c.572,0,1.148-.023,1.724-.07a20.7,20.7,0,1,0-20.906-12.929L198.4,199.9a20.641,20.641,0,0,0-11.613-2.5l-.029,0a20.623,20.623,0,0,0-8.618,2.705l-13.651-11.632a20.738,20.738,0,1,0-40.062-5.713,20.9,20.9,0,0,0,.473,2.968l-18.141,12.494a20.669,20.669,0,0,0-13.714-3.859h0A20.751,20.751,0,0,0,94.669,235.8C95.226,235.8,95.786,235.781,96.346,235.736Zm151.946-79.689a6.674,6.674,0,0,1,4.587-2.343h0c.178-.015.356-.022.531-.022a6.783,6.783,0,0,1,6.736,6.206,6.764,6.764,0,0,1-11.113,5.663,7.1,7.1,0,0,1-.538-.516c-.039-.047-.072-.1-.113-.142s-.064-.063-.095-.1a6.648,6.648,0,0,1-1.59-3.826A6.722,6.722,0,0,1,248.292,156.047Zm-60.4,55.312a6.747,6.747,0,0,1,5.658,11.108,6.726,6.726,0,0,1-11.83-3.864A6.746,6.746,0,0,1,187.9,211.359Zm-47.947-34.581a6.7,6.7,0,0,1,4.619-2.353l.025,0c.186-.015.372-.023.557-.023a6.61,6.61,0,0,1,4.3,1.59,6.735,6.735,0,0,1,2.356,4.647,6.6,6.6,0,0,1-1.572,4.852,6.727,6.727,0,0,1-4.642,2.362,6.6,6.6,0,0,1-4.852-1.572,6.723,6.723,0,0,1-2.362-4.639A6.613,6.613,0,0,1,139.948,176.778ZM90.3,220.183a6.747,6.747,0,0,1,3.841-11.855A6.747,6.747,0,1,1,90.3,220.183Z" />
          </svg>
        </>
      );
    }
    case "connectPay": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.99"
            height="14"
            viewBox="0 0 13.99 14"
          >
            <g
              id="Group_40542"
              dataName="Group 40542"
              transform="translate(22216.238 -2460)"
            >
              <path
                id="Path_28638"
                dataName="Path 28638"
                d="M770.136,664c.092.022.184.041.276.066a2.07,2.07,0,0,1,.95.541c.387.386.775.771,1.159,1.161a.3.3,0,0,0,.238.1q2.029,0,4.058,0h.172v6.06H767.2V669c-.339-.1-.654-.181-.963-.28a.915.915,0,0,1-.311-.167.751.751,0,0,0-.6-.119v.7H763V664h2.324v.435a.957.957,0,0,0,.612-.062c.277-.129.558-.249.837-.373Zm-3.252,2.616a1.288,1.288,0,0,0,.948.382,1.367,1.367,0,0,0,.932-.447c.042.051.073.1.111.135q.612.615,1.226,1.228a.468.468,0,1,0,.67-.652q-.759-.768-1.526-1.527a.451.451,0,0,0-.124-.065l.359-.374c.162.165.317.331.482.487a.285.285,0,0,0,.174.076c.565.006,1.13,0,1.694,0a1.153,1.153,0,0,0,.121-.015c-.293-.29-.572-.558-.841-.837a1.73,1.73,0,0,0-1.32-.548q-1.325.01-2.651,0a1.357,1.357,0,0,0-.679.164,1.9,1.9,0,0,1-.758.292c-.12.008-.241,0-.364,0v3.045c.113,0,.218.008.321,0a.563.563,0,0,1,.38.112,3.061,3.061,0,0,0,.464.257,1.69,1.69,0,0,0,.7.148c0-.345,0-.677,0-1.008,0-.089-.037-.122-.109-.161-.173-.094-.338-.2-.519-.315Zm9.642-.275h-5.984l-.025.035c.117.107.24.208.349.322a.315.315,0,0,0,.251.1q1.8,0,3.608,0h.173a1.081,1.081,0,0,0,.277.9,1.05,1.05,0,0,0,.882.266v1.87a.995.995,0,0,0-1.16,1.159h-5.6a1.058,1.058,0,0,0-.271-.888,1.093,1.093,0,0,0-.877-.274v-1.867a1,1,0,0,0,.967-.38c-.121-.12-.232-.234-.348-.342a.1.1,0,0,0-.09-.022,1.812,1.812,0,0,1-1,.245v3.994h8.849Zm-5.216,1.683a1.216,1.216,0,0,1,1.658.081,1.18,1.18,0,0,1-1.287,1.907,1.153,1.153,0,0,1-.683-.7,1.223,1.223,0,0,1,.081-.989.966.966,0,0,1-1.364-.134c-.086-.086-.17-.176-.263-.272a1.46,1.46,0,0,1-.846.5v.967a1.432,1.432,0,0,1,1.144,1.148h4.69c.225-.7.405-.88,1.158-1.157,0-.288,0-.579,0-.87,0-.027,0-.053-.007-.086a1.425,1.425,0,0,1-1.143-1.139h-3.106A1.109,1.109,0,0,1,771.311,668.024Zm-7.837-3.552v4.187h1.381v-4.187Zm9.321,4.43a.69.69,0,0,0-.689-.7.7.7,0,0,0-.709.7.708.708,0,0,0,.706.7A.7.7,0,0,0,772.8,668.9Z"
                transform="translate(-22979.238 1796)"
              // fill="#fff"
              />
              <path
                id="Path_28639"
                dataName="Path 28639"
                d="M833.158,985.223a1.04,1.04,0,0,1,.784-.628c.828-.213,1.651-.447,2.479-.659a3.466,3.466,0,0,1,.66-.086c.254-.014.51,0,.765,0a1.3,1.3,0,0,1,.751.208c.163.1.331.2.52.312v-.745h2.324v4.649h-2.32v-.341c-.209.081-.4.148-.578.225a1.652,1.652,0,0,1-.665.126q-1.544-.006-3.089,0a1.385,1.385,0,0,1-.738-.207q-2.083-1.252-4.171-2.5a.933.933,0,1,1,.908-1.63c.766.411,1.529.826,2.294,1.239Zm3.686.536c-.881.232-1.739.475-2.606.679a.894.894,0,0,1-1.1-.637.194.194,0,0,0-.081-.1c-.835-.454-1.671-.908-2.511-1.354a.54.54,0,0,0-.3-.047.444.444,0,0,0-.379.378.467.467,0,0,0,.249.49c1.405.842,2.81,1.686,4.22,2.52a.917.917,0,0,0,.439.116c1.061.01,2.123.007,3.184,0a.938.938,0,0,0,.306-.053c.257-.092.508-.2.763-.3a.125.125,0,0,0,.093-.141c0-.77,0-1.54-.005-2.31a.208.208,0,0,0-.084-.148q-.363-.231-.737-.442a.606.606,0,0,0-.266-.1,6.527,6.527,0,0,0-1.226.018c-.6.1-1.182.292-1.771.447q-.548.144-1.094.293a.474.474,0,0,0-.357.563.446.446,0,0,0,.551.339c.587-.145,1.171-.3,1.756-.456l.836-.221Zm4.134-1.671h-1.385V987.8h1.385Z"
                transform="translate(-23043.689 1485.72)"
              // fill="#fff"
              />
            </g>
          </svg>
        </>
      );
    }
    case "profile": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            dataName="Layer 1"
            viewBox="0 0 24 24"
            width="512"
            height="512"
          >
            <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-5,21.797v-.797c0-2.757,2.243-5,5-5s5,2.243,5,5v.797c-1.501.769-3.201,1.203-5,1.203s-3.499-.434-5-1.203Zm11-.582v-.215c0-3.309-2.691-6-6-6s-6,2.691-6,6v.215c-3.008-1.965-5-5.362-5-9.215C1,5.935,5.935,1,12,1s11,4.935,11,11c0,3.853-1.992,7.25-5,9.215ZM12,5c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Zm0,7c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z" />
          </svg>
        </>
      );
    }
    case "reporting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <g id="Reporting" transform="translate(-41 -295)">
              <path
                id="chart-line-up_3_"
                dataName="chart-line-up (3)"
                d="M20.833,191.667H200V200H20.833A20.862,20.862,0,0,1,0,179.167V0H8.333V179.167A12.515,12.515,0,0,0,20.833,191.667Zm120.833-150V50h44.108L125,110.775,91.667,77.442,34.55,134.558l5.892,5.892L91.658,89.233l33.333,33.333,66.675-66.675V100H200V41.667Z"
                transform="translate(41 295)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "teamMembers": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_17"
                  dataName="Rectangle 17"
                  width="200"
                  height="200"
                  transform="translate(276 295)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Team_member_"
              dataName="Team member "
              transform="translate(-276 -295)"
            // clip-path="url(#clip-path)"
            >
              <path
                id="team-check"
                d="M145.827,91.663a54.164,54.164,0,1,0,54.164,54.164A54.227,54.227,0,0,0,145.827,91.663Zm0,100a45.831,45.831,0,1,1,45.831-45.831A45.891,45.891,0,0,1,145.827,191.659Zm27.915-57.139a4.163,4.163,0,0,1-.1,5.891l-22.524,21.782a15.687,15.687,0,0,1-21.857.017L117.9,150.985a4.166,4.166,0,0,1,5.858-5.925l11.35,11.208a7.316,7.316,0,0,0,10.183-.033l22.557-21.816a4.17,4.17,0,0,1,5.891.1ZM45.831,83.33a25,25,0,1,0-25-25A25.029,25.029,0,0,0,45.831,83.33Zm0-41.665A16.666,16.666,0,1,1,29.165,58.331,16.683,16.683,0,0,1,45.831,41.665Zm36.657,76.663a4.161,4.161,0,1,1-6.658,4.991,37.5,37.5,0,0,0-67.506,22.5,4.166,4.166,0,0,1-8.333,0,45.826,45.826,0,0,1,82.488-27.5ZM129.161,50a25,25,0,1,0-25-25A25.029,25.029,0,0,0,129.161,50Zm0-41.665A16.666,16.666,0,1,1,112.5,25,16.683,16.683,0,0,1,129.161,8.333ZM89.4,104.162c-4.083,0-4.666-3.225-3.975-5.416A45.855,45.855,0,0,1,152.077,72.8,4.163,4.163,0,1,1,147.91,80a37.53,37.53,0,0,0-54.539,21.232,4.162,4.162,0,0,1-3.975,2.917Z"
                transform="translate(276.008 295.004)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "ScheduleCalendar": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.044"
            height="19.044"
            viewBox="0 0 19.044 19.044"
          >
            <g id="Layer_3" transform="translate(0.2 0.2)">
              <path
                id="Path_27966"
                dataName="Path 27966"
                d="M18.351,6.32V4.7h-.809V6.32H15.248V4.7h-.809V6.32H11.983V4.7h-.809V6.32H5.4V23.344H24.044V6.32Zm-7.177.853V8.764h.809V7.144h2.482v1.62h.809V7.144h2.293v1.62h.809V7.144h4.884V19.706H6.209V7.173ZM6.209,22.491v-1.9H23.234v1.9Z"
                transform="translate(-5.4 -4.7)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13472"
                dataName="Rectangle 13472"
                width="1.539"
                height="1.539"
                transform="translate(4.641 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13473"
                dataName="Rectangle 13473"
                width="1.539"
                height="1.539"
                transform="translate(8.553 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13474"
                dataName="Rectangle 13474"
                width="1.539"
                height="1.539"
                transform="translate(12.492 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13475"
                dataName="Rectangle 13475"
                width="1.539"
                height="1.539"
                transform="translate(4.641 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13476"
                dataName="Rectangle 13476"
                width="1.539"
                height="1.539"
                transform="translate(8.553 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
              <rect
                id="Rectangle_13477"
                dataName="Rectangle 13477"
                width="1.539"
                height="1.539"
                transform="translate(12.492 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                strokeWidth="0.4"
              />
            </g>
          </svg>
        </>
      );
    }
    case "marketing": {
      return (
        <>
          <svg
            id="Layer_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m60.9 159.3h128.3c10.3 0 18.7-8.4 18.7-18.7v-79.1c0-10.3-8.4-18.7-18.7-18.7h-128.3c-10.3 0-18.7 8.4-18.7 18.7v79.1c-.1 10.3 8.3 18.7 18.7 18.7zm128.3-16h-128.3c-1.5 0-2.7-1.3-2.7-2.7v-74l61.8 51.2c1.5 1.2 3.3 1.8 5.1 1.8s3.6-.6 5.1-1.8l61.8-51.2v73.9c0 1.5-1.3 2.8-2.8 2.8zm-115.5-84.6h102.8l-51.5 42.6zm249.5 72.9h130.4c8.3 0 15.1-6.8 15.1-15.1v-101.4c.1-8.3-6.7-15.1-15.1-15.1h-130.4c-8.3 0-15.1 6.8-15.1 15.1v101.4c0 8.3 6.8 15.1 15.1 15.1zm.9-115.6h128.7v99.6h-128.7zm91.7 42.9-46.8-27c-2.5-1.4-5.5-1.4-8 0s-4 4.1-4 6.9v54.1c0 2.9 1.5 5.5 4 6.9 1.2.7 2.6 1.1 4 1.1s2.8-.4 4-1.1l46.8-27c2.5-1.4 4-4.1 4-6.9s-1.5-5.6-4-7zm-42.8 20.1v-26.4l22.8 13.2zm120.6 92.1h-133c-8.4 0-15.3 6.9-15.3 15.3v2.2h-48.7l-12.2-45.6c-1.9-7-6.4-12.9-12.7-16.6s-13.7-4.6-20.7-2.7c-12.7 3.4-20.9 15.3-20.2 27.9l-43.3 37.7c-1-.4-2-.6-3.1-.6h-134.6c-15.6 0-28.3 12.7-28.3 28.3v231h-10.4c-4.4 0-8 3.6-8 8v18.6c0 20.6 16.8 37.4 37.4 37.4h366.7c20.6 0 37.4-16.8 37.4-37.4v-18.6c0-4.4-3.6-8-8-8h-10.4v-143h67.4c8.4 0 15.3-6.9 15.3-15.3v-103.3c0-8.4-6.8-15.3-15.3-15.3zm-238.5-32c2.9-.8 5.9-.4 8.6 1.2 2.6 1.5 4.5 4 5.3 6.9l44.8 167.1c1.6 6-2 12.2-8 13.9-6 1.6-12.2-2-13.9-8l-44.8-167.2c-1.6-6.1 1.9-12.3 8-13.9zm-90.2 179.4c.3 1 .7 1.9 1.3 2.7l42.7 57.3-31.7 8.5-36.2-51.5-2.8-10.4 26.5-7.1zm-5.7-89.2 18.4 68.7-50.3 13.5c-.3 0-.6.1-1 .2h-.1c-1.4.2-2.7-.1-3.9-.8-1.5-.8-2.5-2.2-2.9-3.8l-15.1-56.5c-.9-3.3 1.1-6.8 4.4-7.7zm34.6 67.4-20-74.5 61-53.1 38.3 143zm234.9 177.9c0 11.8-9.6 21.4-21.4 21.4h-366.8c-11.8 0-21.4-9.6-21.4-21.4v-10.6h137.5v7.9c0 7.8 6.3 14.1 14.1 14.1h106.5c7.8 0 14.1-6.3 14.1-14.1v-7.9h137.5v10.6zm-256.1-10.7h102.6v6h-102.6zm237.7-16h-372.8v-230.9c0-6.8 5.5-12.3 12.3-12.3h120l-8.8 7.6-56.5 15.1c-11.9 3.2-18.9 15.4-15.8 27.3l15.1 56.5c2.4 8.9 9.8 15.1 18.4 16.3l3.6 13.5c.2.9.6 1.8 1.2 2.5l37.1 52.7c3 4.3 7.8 6.8 12.9 6.8 1.4 0 2.8-.2 4.2-.6l31.9-8.5c5.2-1.4 9.1-5.1 10.9-10.1 1.8-5.1.9-10.4-2.3-14.7l-41.2-55.3 7.1-1.9 90.8 17.7c4.7 9.2 14.1 15 24.3 15 2.3 0 4.7-.3 7.1-.9 14.5-3.9 23.2-18.9 19.3-33.5l-28.3-105.5h44.4v85.2c0 8.4 6.9 15.3 15.3 15.3h49.6v142.7zm82.6-158.9h-131.6v-101.9h131.6zm-111.9-50.9c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.4 0-8-3.6-8-8zm38.1 0c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.4 0-8-3.6-8-8zm38.2 0c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.5 0-8-3.6-8-8z" />
          </svg>
        </>
      );
    }
    case "circle-minus": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-circle-minus"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
          </svg>
        </>
      );
    }
    case "plus": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-plus"
          >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </>
      );
    }
    case "circle-plus": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-circle-plus"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
          </svg>
        </>
      );
    }
    case "agentQuery": {
      return (
        <>
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24"
            height="24"
            viewBox="0 0 512 512"
          >
            <g>
              <g>
                <path
                  d="M346,319c-5.522,0-10,4.477-10,10v69c0,27.57-22.43,50-50,50H178.032c-5.521,0-9.996,4.473-10,9.993l-0.014,19.882
			l-23.868-23.867c-1.545-3.547-5.081-6.008-9.171-6.008H70c-27.57,0-50-22.43-50-50V244c0-27.57,22.43-50,50-50h101
			c5.522,0,10-4.477,10-10s-4.478-10-10-10H70c-38.598,0-70,31.402-70,70v154c0,38.598,31.402,70,70,70h59.858l41.071,41.071
			c1.913,1.913,4.47,2.929,7.073,2.929c1.287,0,2.586-0.249,3.821-0.76c3.737-1.546,6.174-5.19,6.177-9.233L188.024,468H286
			c38.598,0,70-31.402,70-70v-69C356,323.477,351.522,319,346,319z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M366.655,0h-25.309C261.202,0,196,65.202,196,145.346s65.202,145.345,145.345,145.345h25.309
			c12.509,0,24.89-1.589,36.89-4.729l37.387,37.366c1.913,1.911,4.469,2.927,7.071,2.927c1.289,0,2.589-0.249,3.826-0.762
			c3.736-1.548,6.172-5.194,6.172-9.238v-57.856c15.829-12.819,28.978-29.012,38.206-47.102
			C506.687,190.751,512,168.562,512,145.346C512,65.202,446.798,0,366.655,0z M441.983,245.535
			c-2.507,1.889-3.983,4.847-3.983,7.988v38.6l-24.471-24.458c-1.904-1.902-4.458-2.927-7.07-2.927c-0.98,0-1.97,0.145-2.936,0.442
			c-11.903,3.658-24.307,5.512-36.868,5.512h-25.309c-69.117,0-125.346-56.23-125.346-125.346S272.23,20,341.346,20h25.309
			C435.771,20,492,76.23,492,145.346C492,185.077,473.77,221.595,441.983,245.535z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M399.033,109.421c-1.443-20.935-18.319-37.811-39.255-39.254c-11.868-0.815-23.194,3.188-31.863,11.281
			c-8.55,7.981-13.453,19.263-13.453,30.954c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10c0-6.259,2.522-12.06,7.1-16.333
			c4.574-4.269,10.552-6.382,16.842-5.948c11.028,0.76,19.917,9.649,20.677,20.676c0.768,11.137-6.539,20.979-17.373,23.403
			c-8.778,1.964-14.908,9.592-14.908,18.549v24.025c0,5.523,4.478,10,10,10c5.523,0,10-4.477,9.999-10v-23.226
			C386.949,148.68,400.468,130.242,399.033,109.421z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M363.87,209.26c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
			c0,2.64,1.071,5.22,2.93,7.08c1.86,1.86,4.44,2.92,7.07,2.92s5.21-1.06,7.07-2.92c1.86-1.87,2.93-4.44,2.93-7.08
			C366.8,213.7,365.729,211.12,363.87,209.26z"
                />
              </g>
            </g>
            <g>
              <g>
                <path d="M275,310H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h211c5.523,0,10-4.477,10-10S280.522,310,275,310z" />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M282.069,368.93C280.21,367.07,277.63,366,275,366s-5.21,1.07-7.07,2.93c-1.861,1.86-2.93,4.44-2.93,7.07
			s1.07,5.21,2.93,7.07c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.861-1.86,2.931-4.43,2.931-7.07
			C285,373.37,283.929,370.79,282.069,368.93z"
                />
              </g>
            </g>
            <g>
              <g>
                <path d="M235.667,366H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h171.667c5.523,0,10-4.477,10-10S241.189,366,235.667,366z" />
              </g>
            </g>
            <g>
              <g>
                <path d="M210,254H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h146c5.523,0,10-4.477,10-10S215.522,254,210,254z" />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </>
      );
    }
    case "remove": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-trash-2"
          >
            <path d="M3 6h18" />
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
            <line x1="10" x2="10" y1="11" y2="17" />
            <line x1="14" x2="14" y1="11" y2="17" />
          </svg>
        </>
      );
    }
    case "star": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-star"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </>
      );
    }
    case "starHalf": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-star-half"
          >
            <path d="M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2" />
          </svg>
        </>
      );
    }
    case "info": {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-info"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      );
    }
    case "chevron-right": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </>
      );
    }
    case "chevron-down": {
      return (
        <>
          <svg
            className={`lucide lucide-chevron-down ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </>
      );
    }
    case "accountingAutomation": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_39429"
              data-name="Group 39429"
              transform="translate(9397 -1654)"
            >
              <rect
                id="Rectangle_13585"
                data-name="Rectangle 13585"
                width="14"
                height="14"
                transform="translate(-9397 1654)"
                fill="#fff"
              />
              <g
                id="Group_39427"
                data-name="Group 39427"
                transform="translate(-8489 2280)"
              >
                <path
                  id="Path_28643"
                  data-name="Path 28643"
                  d="M-908-613.368v-11.374a.6.6,0,0,0,.027-.074,1.444,1.444,0,0,1,.987-1.113c.08-.028.163-.048.244-.071h9.734c.011.007.021.019.033.021a1.46,1.46,0,0,1,1.226,1.513c-.009.332,0,.665,0,1,0,.286-.1.387-.385.387h-1.936v2.331h3.151a.873.873,0,0,1,.919.918c0,.474,0,.948,0,1.422q0,2.747,0,5.5a.866.866,0,0,1-.855.912q-2.645.007-5.29,0a.866.866,0,0,1-.853-.858c0-.1,0-.2,0-.308h-.192q-3.205,0-6.411,0A.4.4,0,0,1-908-613.368Zm9.631-12.051h-8.09a.887.887,0,0,0-.96.964q0,5.276,0,10.552v.141H-901v-.172q0-2.952,0-5.9a.873.873,0,0,1,.911-.912h1.419c0-.067,0-.12,0-.173,0-1.139-.007-2.278,0-3.417A1.512,1.512,0,0,1-898.369-625.419Zm3.787,9.05q0-1.7,0-3.4c0-.3-.1-.4-.39-.4h-5.056c-.292,0-.391.1-.391.4q0,3.4,0,6.792c0,.3.1.4.4.4h5.029c.311,0,.4-.1.4-.411Q-894.582-614.681-894.582-616.368Zm-3.489-7.31h1.739c0-.281,0-.553,0-.825a1.238,1.238,0,0,0-.021-.217.879.879,0,0,0-.862-.7.852.852,0,0,0-.848.725C-898.1-624.361-898.071-624.023-898.071-623.679Z"
                />
                <path
                  id="Path_28644"
                  data-name="Path 28644"
                  d="M-856.853-514.282h2.8c.258,0,.4.1.4.288s-.14.3-.4.3h-5.6a.811.811,0,0,1-.2-.02.279.279,0,0,1-.2-.275.279.279,0,0,1,.207-.273.764.764,0,0,1,.189-.019Z"
                  transform="translate(-46.184 -107.637)"
                />
                <path
                  id="Path_28645"
                  data-name="Path 28645"
                  d="M-856.865-553.57h-2.815a.771.771,0,0,1-.19-.014.288.288,0,0,1-.2-.293.293.293,0,0,1,.249-.269.939.939,0,0,1,.136,0q2.822,0,5.644,0a.629.629,0,0,1,.2.025.276.276,0,0,1,.18.3.282.282,0,0,1-.253.247,1.4,1.4,0,0,1-.15,0Z"
                  transform="translate(-46.179 -69.224)"
                />
                <path
                  id="Path_28646"
                  data-name="Path 28646"
                  d="M-857.743-394.516h1.941a.868.868,0,0,1,.163.01.287.287,0,0,1,.239.277.289.289,0,0,1-.241.289.789.789,0,0,1-.149.01h-3.881a.885.885,0,0,1-.136-.006.289.289,0,0,1-.257-.289.288.288,0,0,1,.259-.287,1.03,1.03,0,0,1,.15-.006Z"
                  transform="translate(-46.184 -223.029)"
                />
                <path
                  id="Path_28647"
                  data-name="Path 28647"
                  d="M-857.82-473.654c-.66,0-1.321,0-1.981-.005a.424.424,0,0,1-.274-.113.278.278,0,0,1,.177-.457,1.042,1.042,0,0,1,.15-.005h3.922c.218,0,.354.118.349.3s-.137.285-.347.285Z"
                  transform="translate(-46.106 -146.222)"
                />
                <path
                  id="Path_28648"
                  data-name="Path 28648"
                  d="M-857.777-433.8c-.661,0-1.321,0-1.982,0a.489.489,0,0,1-.243-.064.251.251,0,0,1-.105-.289.284.284,0,0,1,.235-.22.557.557,0,0,1,.109,0h3.963c.223,0,.363.126.349.31a.3.3,0,0,1-.331.271C-856.447-433.8-857.112-433.8-857.777-433.8Z"
                  transform="translate(-46.135 -184.624)"
                />
                <path
                  id="Path_28649"
                  data-name="Path 28649"
                  d="M-857.742-353.886q-.984,0-1.968,0a.577.577,0,0,1-.174-.021.282.282,0,0,1-.192-.3.287.287,0,0,1,.258-.258,1.168,1.168,0,0,1,.123,0h3.894c.041,0,.082,0,.123,0a.288.288,0,0,1,.265.28.292.292,0,0,1-.253.294.967.967,0,0,1-.136,0Z"
                  transform="translate(-46.173 -261.615)"
                />
                <path
                  id="Path_28650"
                  data-name="Path 28650"
                  d="M-682.051-447.371h-1.941c-.3,0-.386-.088-.386-.379q0-1.08,0-2.16c0-.283.091-.372.379-.373h3.909c.283,0,.373.091.373.379q0,1.08,0,2.16c0,.283-.092.373-.379.373Zm1.747-2.321h-3.483v1.733h3.483Z"
                  transform="translate(-215.453 -169.298)"
                />
                <path
                  id="Path_28651"
                  data-name="Path 28651"
                  d="M-683.752-322.143c-.1,0-.192.006-.286,0a.285.285,0,0,1-.283-.291.281.281,0,0,1,.282-.29c.2-.009.4-.009.6,0a.278.278,0,0,1,.276.282.283.283,0,0,1-.275.3c-.1.009-.209,0-.314,0Z"
                  transform="translate(-215.509 -292.191)"
                />
                <path
                  id="Path_28652"
                  data-name="Path 28652"
                  d="M-635.835-322.665c.1,0,.2-.007.3,0a.283.283,0,0,1,.278.294.276.276,0,0,1-.273.284,5.862,5.862,0,0,1-.614,0,.277.277,0,0,1-.272-.286.284.284,0,0,1,.28-.293C-636.035-322.672-635.935-322.665-635.835-322.665Z"
                  transform="translate(-261.666 -292.252)"
                />
                <path
                  id="Path_28653"
                  data-name="Path 28653"
                  d="M-587.942-322.15c-.1,0-.192.006-.286,0a.285.285,0,0,1-.28-.293.281.281,0,0,1,.285-.288c.2-.009.391-.009.587,0a.281.281,0,0,1,.287.286.287.287,0,0,1-.291.3c-.1.007-.2,0-.3,0Z"
                  transform="translate(-307.822 -292.185)"
                />
                <path
                  id="Path_28654"
                  data-name="Path 28654"
                  d="M-683.748-290.15c-.1,0-.21.006-.314,0a.275.275,0,0,1-.26-.281.275.275,0,0,1,.251-.29,6.4,6.4,0,0,1,.654,0,.275.275,0,0,1,.252.3.275.275,0,0,1-.271.27c-.1.006-.209,0-.314,0Z"
                  transform="translate(-215.508 -323.024)"
                />
                <path
                  id="Path_28655"
                  data-name="Path 28655"
                  d="M-635.839-290.152c-.1,0-.2,0-.3,0a.276.276,0,0,1-.272-.269.276.276,0,0,1,.251-.3,6.275,6.275,0,0,1,.654,0,.275.275,0,0,1,.252.3.275.275,0,0,1-.271.27C-635.63-290.147-635.735-290.152-635.839-290.152Z"
                  transform="translate(-261.668 -323.02)"
                />
                <path
                  id="Path_28656"
                  data-name="Path 28656"
                  d="M-587.93-290.151c-.1,0-.2,0-.3,0a.277.277,0,0,1-.277-.279.277.277,0,0,1,.261-.3c.213-.009.428-.01.641,0a.276.276,0,0,1,.256.3.279.279,0,0,1-.267.275l-.027,0h-.287Z"
                  transform="translate(-307.824 -323.021)"
                />
                <path
                  id="Path_28657"
                  data-name="Path 28657"
                  d="M-683.743-353.929c-.1,0-.2,0-.3,0a.285.285,0,0,1-.282-.29.276.276,0,0,1,.283-.286c.2-.006.4-.006.6,0a.274.274,0,0,1,.275.28.284.284,0,0,1-.276.3C-683.542-353.924-683.643-353.929-683.743-353.929Z"
                  transform="translate(-215.505 -261.573)"
                />
                <path
                  id="Path_28658"
                  data-name="Path 28658"
                  d="M-635.849-353.933c-.091,0-.182,0-.273,0a.288.288,0,0,1-.3-.287.279.279,0,0,1,.292-.292q.286-.007.573,0a.279.279,0,0,1,.294.29.287.287,0,0,1-.3.288C-635.657-353.93-635.753-353.933-635.849-353.933Z"
                  transform="translate(-261.658 -261.568)"
                />
                <path
                  id="Path_28659"
                  data-name="Path 28659"
                  d="M-587.92-353.931c-.1,0-.2,0-.3,0a.285.285,0,0,1-.288-.3.277.277,0,0,1,.291-.279c.2,0,.391-.005.587,0a.276.276,0,0,1,.281.288.285.285,0,0,1-.284.288C-587.729-353.927-587.824-353.931-587.92-353.931Z"
                  transform="translate(-307.823 -261.57)"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }

    // agent profile
    case "basicDetails": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Basic_Details_"
              data-name="Basic Details "
              transform="translate(-427 -112)"
            >
              <g
                id="Layer_2"
                data-name="Layer 2"
                transform="translate(419.631 103.429)"
              >
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M21.663,128.571H94.286a4.286,4.286,0,0,0,0-8.571H21.663a4.525,4.525,0,0,1-4.52-4.52V21.663a4.525,4.525,0,0,1,4.52-4.52H94.286a4.286,4.286,0,0,0,0-8.571H21.663A13.105,13.105,0,0,0,8.571,21.663V115.48a13.105,13.105,0,0,0,13.092,13.092Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M75.264,111.429h38.044a12.857,12.857,0,0,0,12.474-15.975L123.118,84.8A21.4,21.4,0,0,0,102.33,68.571H86.241A21.4,21.4,0,0,0,65.456,84.8L62.792,95.454a12.857,12.857,0,0,0,12.472,15.975Zm-4.157-13.9L73.77,86.88a12.836,12.836,0,0,1,12.471-9.737H102.33A12.835,12.835,0,0,1,114.8,86.882l2.664,10.651a4.286,4.286,0,0,1-4.158,5.324H75.264a4.286,4.286,0,0,1-4.157-5.324Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M94.286,25.714a17.143,17.143,0,1,0,17.143,17.143A17.143,17.143,0,0,0,94.286,25.714Zm0,25.714a8.571,8.571,0,1,1,8.571-8.571A8.571,8.571,0,0,1,94.286,51.429Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M30,34.286H51.429a4.286,4.286,0,0,0,0-8.571H30a4.286,4.286,0,1,0,0,8.571Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M30,60a4.286,4.286,0,1,0,0,8.571H51.429a4.286,4.286,0,0,0,0-8.571Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M68.571,47.143a4.286,4.286,0,0,0-4.286-4.286H30a4.286,4.286,0,1,0,0,8.571H64.286A4.286,4.286,0,0,0,68.571,47.143Z"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "myCredentials": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="122"
            viewBox="0 0 120 122"
          >
            <g
              id="My_Credential"
              data-name="My Credential"
              transform="translate(-601 -110)"
            >
              <g id="graduation_2888958" transform="translate(586 96)">
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M108,15H42A15.017,15.017,0,0,0,27,30v90a15.017,15.017,0,0,0,15,15h66a15.017,15.017,0,0,0,15-15V30A15.017,15.017,0,0,0,108,15Zm9,105a9.011,9.011,0,0,1-9,9H42a9.011,9.011,0,0,1-9-9V30a9.011,9.011,0,0,1,9-9h66a9.011,9.011,0,0,1,9,9Z"
                  stroke="#000"
                  strokeWidth="0.2"
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M60,78a15,15,0,0,0-3,29.694V120a3,3,0,0,0,6,0V107.694A15,15,0,0,0,60,78Zm0,24a9,9,0,1,1,9-9A9.011,9.011,0,0,1,60,102Z"
                  stroke="#000"
                  strokeWidth="0.2"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M102,33H48a3,3,0,0,0,0,6h54a3,3,0,0,0,0-6Z"
                  stroke="#000"
                  strokeWidth="0.2"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M102,51H48a3,3,0,0,0,0,6h54a3,3,0,0,0,0-6Z"
                  stroke="#000"
                  strokeWidth="0.2"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "mySchedule": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g id="Schedule" transform="translate(-1123 -149)">
              <g id="g1995" transform="translate(1114.429 311.857)">
                <path
                  id="path1964"
                  d="M895.714,694.286a4.286,4.286,0,0,0-4.286,4.286v4.286h-8.571A17.2,17.2,0,0,0,865.714,720v77.143a17.2,17.2,0,0,0,17.143,17.143h38.571a4.286,4.286,0,0,0,0-8.571H882.857a8.46,8.46,0,0,1-8.571-8.571v-60H977.143V750a4.286,4.286,0,0,0,8.571,0V720a17.2,17.2,0,0,0-17.143-17.143H960v-4.286a4.286,4.286,0,0,0-8.571,0v4.286H930v-4.286a4.286,4.286,0,0,0-8.571,0v4.286H900v-4.286A4.286,4.286,0,0,0,895.714,694.286Zm-12.857,17.143h8.571v4.286a4.286,4.286,0,1,0,8.571,0v-4.286h21.429v4.286a4.286,4.286,0,1,0,8.571,0v-4.286h21.429v4.286a4.286,4.286,0,1,0,8.571,0v-4.286h8.571A8.46,8.46,0,0,1,977.143,720v8.571H874.286V720A8.46,8.46,0,0,1,882.857,711.429Z"
                  transform="translate(-857.143 -857.143)"
                  stroke="#fff"
                  strokeWidth="3"
                />
                <path
                  id="path1979"
                  d="M98.571-102.857a30.065,30.065,0,0,0-30,30,30.065,30.065,0,0,0,30,30,30.065,30.065,0,0,0,30-30A30.065,30.065,0,0,0,98.571-102.857Zm0,8.571A21.364,21.364,0,0,1,120-72.857,21.364,21.364,0,0,1,98.571-51.429,21.364,21.364,0,0,1,77.143-72.857,21.364,21.364,0,0,1,98.571-94.286Z"
                  stroke="#fff"
                  strokeWidth="3"
                />
                <path
                  id="path1986"
                  d="M98.571-85.714a4.286,4.286,0,0,0-4.286,4.286v8.571a4.286,4.286,0,0,0,4.285,4.286h8.572a4.286,4.286,0,0,0,4.286-4.286,4.286,4.286,0,0,0-4.286-4.286h-4.286v-4.286A4.286,4.286,0,0,0,98.571-85.714Z"
                  stroke="#fff"
                  strokeWidth="3"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "bankInfo": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Bank_Info"
              data-name="Bank Info"
              transform="translate(-775 -111)"
            >
              <path
                id="museum_6048118"
                d="M107.2,55.421a1.875,1.875,0,0,0,1.875-1.875V44.69h4.574a1.875,1.875,0,0,0,1.875-1.875V32.852a1.876,1.876,0,0,0-.937-1.624L60.937.251a1.874,1.874,0,0,0-1.875,0L5.409,31.228a1.875,1.875,0,0,0-.937,1.624v9.964A1.875,1.875,0,0,0,6.347,44.69H10.92v8.856A1.875,1.875,0,0,0,12.8,55.421H13.9v50.1H12.024a7.561,7.561,0,0,0-7.552,7.553v5.053A1.875,1.875,0,0,0,6.347,120H113.653a1.875,1.875,0,0,0,1.875-1.875v-5.053a7.561,7.561,0,0,0-7.552-7.553H106.1v-50.1ZM8.222,33.934,60,4.04l51.779,29.895V40.94H8.222Zm61.448,71.585v-50.1H86.758v50.1Zm-36.428,0v-50.1H50.331v50.1Zm20.839-50.1H65.92v50.1H54.081ZM14.67,51.671V44.691h90.659v6.981m-87.677,3.75H29.492v50.1H17.652Zm90.324,53.848a3.807,3.807,0,0,1,3.8,3.8v3.178H8.222v-3.178a3.807,3.807,0,0,1,3.8-3.8m90.323-3.75H90.508v-50.1h11.839ZM60,15.648A10.248,10.248,0,1,0,70.248,25.9,10.259,10.259,0,0,0,60,15.648Zm0,16.745a6.5,6.5,0,1,1,6.5-6.5A6.505,6.505,0,0,1,60,32.392Z"
                transform="translate(775 111.5)"
                stroke="#000"
                strokeWidth="1"
              />
            </g>
          </svg>
        </>
      );
    }
    case "manageReview": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Manage_review_link_"
              data-name="Manage review link "
              transform="translate(-949 -138)"
            >
              <g
                id="Group_1"
                data-name="Group 1"
                transform="translate(0 27.627)"
              >
                <g id="Icon" transform="translate(942.023 104.024)">
                  <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M126.977,30.7a15.34,15.34,0,0,0-15.349-15.349h-89.3A15.34,15.34,0,0,0,6.977,30.7V86.512A15.347,15.347,0,0,0,22.326,101.86H46.767l17.408,15.667a4.187,4.187,0,0,0,5.6,0L87.187,101.86h24.441a15.347,15.347,0,0,0,15.349-15.349Zm-8.372,0V86.512a6.979,6.979,0,0,1-6.977,6.977H85.58a4.172,4.172,0,0,0-2.8,1.077L66.977,108.787,51.17,94.566a4.172,4.172,0,0,0-2.8-1.077H22.326a6.979,6.979,0,0,1-6.977-6.977V30.7a6.975,6.975,0,0,1,6.977-6.977h89.3A6.975,6.975,0,0,1,118.6,30.7Z"
                    stroke="#fff"
                    strokeWidth="3"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M58.6,37.674H47.442a20.93,20.93,0,1,0,0,41.86H58.6a4.186,4.186,0,1,0,0-8.372H47.442a12.558,12.558,0,1,1,0-25.116H58.6a4.186,4.186,0,1,0,0-8.372Z"
                    stroke="#fff"
                    strokeWidth="3"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M107.442,58.6a20.924,20.924,0,0,0-20.93-20.93H75.349a4.186,4.186,0,0,0,0,8.372H86.512A12.558,12.558,0,0,1,99.07,58.6v.05A12.558,12.558,0,0,1,86.512,71.163H75.349a4.186,4.186,0,0,0,0,8.372H86.512a20.924,20.924,0,0,0,20.93-20.93Zm-3.751,3.751c-.268.112-.435.24-.435.435Z"
                    stroke="#fff"
                    strokeWidth="3"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M53.023,62.791H80.93a4.186,4.186,0,1,0,0-8.372H53.023a4.186,4.186,0,0,0,0,8.372Z"
                    stroke="#fff"
                    strokeWidth="3"
                    fill-rule="evenodd"
                  />
                </g>
                <path
                  id="Path_25"
                  data-name="Path 25"
                  d="M1043.789,164.775h0l1.077-.4,1.171-.187.131.17.735.954a12.362,12.362,0,0,1,0,1.615c-.07.094-.492.96-.492.96a6.221,6.221,0,0,1-.375,1.194c-.117.094-.4,1.335-.585,1.592s-1.1,1.147-1.662.983a2.262,2.262,0,0,1-1.381-1.194,8.44,8.44,0,0,1,0-2.177,11.826,11.826,0,0,1,1.381-3.512"
                  transform="translate(71.657 -247.73) rotate(14)"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "invoicepending": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.285"
            height="22.831"
            viewBox="0 0 18.285 22.831"
          >
            <g
              id="Group_39487"
              data-name="Group 39487"
              transform="translate(0.05 0.05)"
            >
              <path
                id="Path_27776"
                data-name="Path 27776"
                d="M19.273,35.458H17v2.273H35.184V35.458H32.911v-3.88L27.7,26.365l5.212-5.212v-3.88h2.273V15H17v2.273h2.273v3.88l5.212,5.212-5.212,5.212Zm2.273-15.245V17.273h9.092v2.939l-4.546,4.546Zm4.546,7.76,4.546,4.546v2.939H21.546V32.518Z"
                transform="translate(-17 -15)"
                fill="#4b96cd"
                stroke="#4a96cc"
                strokeWidth="0.1"
              />
            </g>
          </svg>
        </>
      );
    }
    case "invoicePaid": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24.762"
            height="24.493"
            viewBox="0 0 24.762 24.493"
          >
            <g
              id="Group_38386"
              data-name="Group 38386"
              transform="translate(0 0)"
            >
              <rect
                id="Rectangle_13383"
                data-name="Rectangle 13383"
                width="24.493"
                height="24.493"
                transform="translate(0.001 0)"
                opacity="0"
              />
              <g
                id="Group_38123"
                data-name="Group 38123"
                transform="translate(0 0.662)"
              >
                <path
                  id="Path_27780"
                  data-name="Path 27780"
                  d="M251.061,144.253h1.226a.234.234,0,0,0,.235-.235v-1.226A2.933,2.933,0,0,0,255,140.261a2.874,2.874,0,0,0-2.87-3.157h-.913a1.2,1.2,0,0,1-1.2-1.331,1.224,1.224,0,0,1,1.252-1.07h1.07a.839.839,0,0,1,.809.652.251.251,0,0,0,.235.183h1.226a.227.227,0,0,0,.235-.261,2.513,2.513,0,0,0-2.348-2.244v-1.2a.234.234,0,0,0-.235-.235h-1.2a.234.234,0,0,0-.235.235v1.2a2.894,2.894,0,0,0-2.479,3.131,2.974,2.974,0,0,0,3,2.583h.783a1.2,1.2,0,0,1,1.2,1.331,1.224,1.224,0,0,1-1.252,1.07h-1.1a.838.838,0,0,1-.809-.652.251.251,0,0,0-.235-.183h-1.226a.227.227,0,0,0-.235.261,2.513,2.513,0,0,0,2.348,2.244v1.2a.234.234,0,0,0,.235.235Z"
                  transform="translate(-240.676 -126.928)"
                />
                <path
                  id="Path_27781"
                  data-name="Path 27781"
                  d="M94.983,51.424a9.08,9.08,0,1,1,9.08-9.08,10.08,10.08,0,0,1-.209,2.009,1.273,1.273,0,0,1,.313-.026,5.643,5.643,0,0,1,1.618.235,10.322,10.322,0,0,0,.209-2.218A11,11,0,1,0,94.983,53.329a10.681,10.681,0,0,0,4.2-.835,5.309,5.309,0,0,1-.574-1.853,8.776,8.776,0,0,1-3.627.783Z"
                  transform="translate(-83.998 -31.36)"
                />
                <path
                  id="Path_27782"
                  data-name="Path 27782"
                  d="M421.844,330.4a4.618,4.618,0,1,0,4.592,4.618A4.572,4.572,0,0,0,421.844,330.4Zm2.009,3.731-2.113,2.5a.446.446,0,0,1-.679,0l-1.2-1.435a.463.463,0,0,1,.7-.6l.861,1.018,1.748-2.087a.481.481,0,0,1,.652-.052A.512.512,0,0,1,423.854,334.131Z"
                  transform="translate(-401.675 -316.467)"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "CantComplete": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Layer_2"
              data-name="Layer 2"
              transform="translate(-5.455 -5.455)"
            >
              <path
                id="Path_27743"
                data-name="Path 27743"
                d="M65.455,125.455a60.071,60.071,0,0,1-60-60,5.455,5.455,0,1,1,10.909,0A49.091,49.091,0,1,0,65.455,16.364a5.455,5.455,0,1,1,0-10.909,60,60,0,1,1,0,120Z"
              />
              <path
                id="Path_27744"
                data-name="Path 27744"
                d="M65.455,125.455a60.049,60.049,0,0,1-17.727-2.662,5.456,5.456,0,0,1,3.213-10.429,49,49,0,0,0,14.515,2.182,5.455,5.455,0,1,1,0,10.909ZM30.327,112.636a5.454,5.454,0,0,1-3.513-1.276A59.864,59.864,0,0,1,12,92.727a5.454,5.454,0,1,1,9.716-4.959,48.911,48.911,0,0,0,12.141,15.273,5.455,5.455,0,0,1-3.529,9.595ZM11.695,80.215a5.455,5.455,0,0,1-5.373-4.533,60.954,60.954,0,0,1-.867-10.227A60.316,60.316,0,0,1,7,51.867a5.454,5.454,0,1,1,10.625,2.465,49.669,49.669,0,0,0-.545,19.511,5.455,5.455,0,0,1-4.456,6.3,5.36,5.36,0,0,1-.927.071Zm9.627-41.367a5.455,5.455,0,0,1-4.413-8.662A60.273,60.273,0,0,1,29.487,17.422a5.457,5.457,0,1,1,6.562,8.722A49.538,49.538,0,0,0,25.735,36.6a5.455,5.455,0,0,1-4.413,2.247Zm31.042-20.9A5.455,5.455,0,0,1,51.033,7.2,60.463,60.463,0,0,1,65.455,5.455a5.455,5.455,0,1,1,0,10.909,49.282,49.282,0,0,0-11.809,1.429A5.455,5.455,0,0,1,52.364,17.951Z"
              />
              <path
                id="Path_27745"
                data-name="Path 27745"
                d="M58.184,85.456a5.422,5.422,0,0,1-3.862-1.6L39.78,69.311A5.454,5.454,0,1,1,47.493,61.6l10.69,10.686L83.416,47.051a5.456,5.456,0,1,1,7.713,7.718L62.04,83.858a5.416,5.416,0,0,1-3.856,1.6Z"
              />
            </g>
          </svg>
        </>
      );
    }
    case "statusPending": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_9"
                  data-name="Rectangle 9"
                  width="120"
                  height="120"
                  transform="translate(253 481)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_2"
              data-name="Mask Group 2"
              transform="translate(-253 -481)"
              clip-path="url(#clip-path)"
            >
              <path
                id="Path_27742"
                data-name="Path 27742"
                d="M29,123H17v12h96V123H101V102.516L73.484,75,101,47.484V27h12V15H17V27H29V47.484L56.516,75,29,102.516ZM41,42.516V27H89V42.516l-24,24ZM65,83.484l24,24V123H41V107.484l24-24Z"
                transform="translate(248 465.5)"
                stroke="#fff"
                strokeWidth="3"
              />
            </g>
          </svg>
        </>
      );
    }
    case "closed": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_11"
                  data-name="Rectangle 11"
                  width="120"
                  height="120"
                  transform="translate(601 353)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Mask_Group_3"
              data-name="Mask Group 3"
              transform="translate(-601 -353)"
            >
              <path
                id="check-mark_1442912_1_"
                data-name="check-mark_1442912 (1)"
                d="M86.523,40.962a4.687,4.687,0,0,1,0,6.629L55.076,79.039a4.689,4.689,0,0,1-6.629,0L33.477,64.068a4.687,4.687,0,1,1,6.628-6.628L51.761,69.1,79.893,40.962a4.689,4.689,0,0,1,6.629,0ZM120,60A60,60,0,1,1,60,0,59.967,59.967,0,0,1,120,60Zm-9.375,0A50.625,50.625,0,1,0,60,110.625,50.6,50.6,0,0,0,110.625,60Zm0,0"
                transform="translate(601 353)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "cancelled": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_10"
                  data-name="Rectangle 10"
                  width="120"
                  height="120"
                  transform="translate(427 353)"
                  fill="#fff"
                  stroke="#707070"
                  strokeWidth="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Mask_Group_1"
              data-name="Mask Group 1"
              transform="translate(-427 -353)"
            >
              <g id="b" transform="translate(427 353)">
                <path
                  id="Path_27739"
                  data-name="Path 27739"
                  d="M60,0a60,60,0,1,0,60,60A60,60,0,0,0,60,0ZM96.129,96.129a50.922,50.922,0,1,1,10.952-16.245A50.9,50.9,0,0,1,96.129,96.129Z"
                />
                <path
                  id="Path_27740"
                  data-name="Path 27740"
                  d="M84.759,35.241a4.453,4.453,0,0,0-6.3,0L60,53.7,41.538,35.241a4.453,4.453,0,0,0-6.3,6.3L53.7,60,35.241,78.462a4.452,4.452,0,1,0,6.3,6.3L60,66.3,78.459,84.759a4.452,4.452,0,1,0,6.3-6.3L66.293,60,84.755,41.538a4.453,4.453,0,0,0,0-6.3Z"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "ditNotClose": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Mask_Group_4"
              data-name="Mask Group 4"
              transform="translate(-775 -353)"
            >
              <g id="minus_992683" transform="translate(775 353)">
                <g id="Group_37897" data-name="Group 37897">
                  <g id="Group_37896" data-name="Group 37896">
                    <path
                      id="Path_27746"
                      data-name="Path 27746"
                      d="M60,0a60,60,0,1,0,60,60A60.069,60.069,0,0,0,60,0Zm0,110.7A50.7,50.7,0,1,1,110.7,60,50.761,50.761,0,0,1,60,110.7Z"
                    />
                  </g>
                </g>
                <g id="Group_37899" data-name="Group 37899">
                  <g id="Group_37898" data-name="Group 37898">
                    <path
                      id="Path_27747"
                      data-name="Path 27747"
                      d="M83.238,54.934H36.762a4.648,4.648,0,0,0,0,9.3H83.238a4.648,4.648,0,0,0,0-9.3Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "arrived": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Mask_Group_5"
              data-name="Mask Group 5"
              transform="translate(-949 -353)"
            >
              <g id="enter_1828391" transform="translate(949 355.527)">
                <path
                  id="Path_27748"
                  data-name="Path 27748"
                  d="M79.565,61.386H3.913a3.913,3.913,0,1,1,0-7.826H79.565a3.913,3.913,0,1,1,0,7.826Zm0,0"
                />
                <path
                  id="Path_27749"
                  data-name="Path 27749"
                  d="M58.7,82.255a3.915,3.915,0,0,1-2.766-6.683l18.1-18.1-18.1-18.1a3.915,3.915,0,0,1,5.536-5.536L82.335,54.7a3.914,3.914,0,0,1,0,5.535L61.466,81.1a3.884,3.884,0,0,1-2.77,1.153Zm0,0"
                />
                <path
                  id="Path_27750"
                  data-name="Path 27750"
                  d="M62.609,114.864a57.094,57.094,0,0,1-53.415-36.4,3.912,3.912,0,1,1,7.283-2.858,49.565,49.565,0,1,0,0-36.272,3.912,3.912,0,1,1-7.283-2.858,57.392,57.392,0,1,1,53.415,78.386Zm0,0"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "check": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </>
      );
    }
    case "pending": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-clock"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </>
      );
    }

    case "rejected": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </>
      );
    }

    case "circleCheck": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-check-big"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335" />
            <path d="m9 11 3 3L22 4" />
          </svg>
        </>
      );
    }
    case "logArrowRight": {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-move-right"
        >
          <path d="M18 8L22 12L18 16" />
          <path d="M2 12H22" />
        </svg>
      );
    }

    case "download": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-arrow-down-to-line"
          >
            <path d="M12 17V3" />
            <path d="m6 11 6 6 6-6" />
            <path d="M19 21H5" />
          </svg>
        </>
      );
    }
    case "TotalOrders": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16.904"
            height="23.488"
            viewBox="0 0 16.904 23.488"
          >
            <g
              id="_1954198_order_list_icon"
              data-name="1954198_order_list_icon"
              transform="translate(-29.675 -22.05)"
            >
              <path
                id="Path_27947"
                data-name="Path 27947"
                d="M51.845,38.49V24.727A1.727,1.727,0,0,0,50.118,23H41.564"
                transform="translate(-6.216)"
                fill="none"
                stroke="#4a95cd"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.9"
              />
              <path
                id="Path_27948"
                data-name="Path 27948"
                d="M33.431,23H32.352a1.727,1.727,0,0,0-1.727,1.727V42.861a1.727,1.727,0,0,0,1.727,1.727H43.9a1.727,1.727,0,0,0,1.727-1.727v-2.59"
                fill="none"
                stroke="#4a95cd"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.9"
              />
              <line
                id="Line_481"
                data-name="Line 481"
                x2="8.953"
                transform="translate(33.651 33.794)"
                fill="none"
                stroke="#4a95cd"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.9"
              />
              <line
                id="Line_482"
                data-name="Line 482"
                x2="5.475"
                transform="translate(33.65 38.548)"
                fill="none"
                stroke="#4a95cd"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.9"
              />
              <line
                id="Line_483"
                data-name="Line 483"
                x2="8.953"
                transform="translate(33.651 29.04)"
                fill="none"
                stroke="#4a95cd"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.9"
              />
            </g>
          </svg>
        </>
      );
    }
    case "TotalIncome": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28.926"
            height="19.951"
            viewBox="0 0 28.926 19.951"
          >
            <g
              id="_405-Money"
              data-name="405-Money"
              transform="translate(0 -5)"
            >
              <path
                id="Path_27770"
                data-name="Path 27770"
                d="M17.155,23.951H1V6H27.926v9.873"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <circle
                id="Ellipse_3108"
                data-name="Ellipse 3108"
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="translate(10 10.951)"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_27771"
                data-name="Path 27771"
                d="M7.693,10H5v2.693"
                transform="translate(-0.41 -0.41)"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_27772"
                data-name="Path 27772"
                d="M26.693,12.693V10H24"
                transform="translate(-2.357 -0.41)"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_27773"
                data-name="Path 27773"
                d="M5,19v2.693H7.693"
                transform="translate(-0.41 -1.332)"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_27774"
                data-name="Path 27774"
                d="M22,22.693l2.693,2.693L30.078,20"
                transform="translate(-2.152 -1.435)"
                fill="none"
                stroke="#4a95cd"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </g>
          </svg>
        </>
      );
    }
    case "Expenses": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.249"
            height="24.798"
            viewBox="0 0 27.249 24.798"
          >
            <path
              id="_8726132_money_insert_icon"
              data-name="8726132_money_insert_icon"
              d="M12.588,6.9l.661-.723v4.4a1.225,1.225,0,1,0,2.45,0v-4.4l.661.674a1.231,1.231,0,1,0,1.788-1.69L15.344,2.354a1.266,1.266,0,0,0-1.739,0L10.8,5.11A1.265,1.265,0,1,0,12.588,6.9Zm1.886,7.35a3.675,3.675,0,1,0,3.675,3.675A3.675,3.675,0,0,0,14.475,14.249Zm0,4.9A1.225,1.225,0,1,1,15.7,17.923,1.225,1.225,0,0,1,14.475,19.148ZM5.9,17.923A1.225,1.225,0,1,0,7.125,16.7,1.225,1.225,0,0,0,5.9,17.923Zm17.149,0a1.225,1.225,0,1,0-1.225,1.225A1.225,1.225,0,0,0,23.049,17.923Zm1.225-8.575h-4.9a1.225,1.225,0,1,0,0,2.45h4.9A1.225,1.225,0,0,1,25.5,13.024v9.8a1.225,1.225,0,0,1-1.225,1.225H4.675A1.225,1.225,0,0,1,3.45,22.823v-9.8A1.225,1.225,0,0,1,4.675,11.8h4.9a1.225,1.225,0,0,0,0-2.45h-4.9A3.675,3.675,0,0,0,1,13.024v9.8A3.675,3.675,0,0,0,4.675,26.5h19.6a3.675,3.675,0,0,0,3.675-3.675v-9.8A3.675,3.675,0,0,0,24.274,9.349Z"
              transform="translate(-0.85 -1.851)"
              fill="#4a95cd"
              stroke="#e3faff"
              stroke-width="0.3"
            />
          </svg>
        </>
      );
    }
    case "upload": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class={`lucide lucide-upload ${className}`}
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" x2="12" y1="3" y2="15" />
          </svg>
        </>
      );
    }
    case "asterisk": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-asterisk"
          >
            <path d="M12 6v12" />
            <path d="M17.196 9 6.804 15" />
            <path d="m6.804 9 10.392 6" />
          </svg>
        </>
      );
    }
    case "dot": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="4.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-dot"
          >
            <circle cx="12.1" cy="12.1" r="4" />
          </svg>
        </>
      );
    }
    case "creditCard": {
      return (
        <>
          <svg
            id="Layer_1"
            enable-background="new 0 0 128 128"
            viewBox="0 0 128 128"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path d="m104 11h-80c-12.68 0-23 10.32-23 23v60c0 12.68 10.32 23 23 23h80c12.68 0 23-10.32 23-23v-60c0-12.68-10.32-23-23-23zm-55 86h-30c-1.66 0-3-1.34-3-3s1.34-3 3-3h30c1.66 0 3 1.34 3 3s-1.34 3-3 3zm30 0h-10c-1.66 0-3-1.34-3-3s1.34-3 3-3h10c1.66 0 3 1.34 3 3s-1.34 3-3 3zm42-45h-114v-18h114z" />
            </g>
          </svg>
        </>
      );
    }
    case "dSync": {
      return (
        <>
          <svg
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.468 3.687l-.757-.706a6 6 0 0 1 9.285 4.799L15.19 6.6l.75.76-2.09 2.07-.76-.01L11 7.31l.76-.76 1.236 1.25a5 5 0 0 0-7.528-4.113zm4.55 8.889l.784.73a6 6 0 0 1-8.796-5.04L.78 9.5 0 8.73l2.09-2.07.76.01 2.09 2.12-.76.76-1.167-1.18a5 5 0 0 0 7.005 4.206z"
            />
            <path d="M1.123 2.949l.682-.732L13.72 13.328l-.682.732z" />
          </svg>
        </>
      );
    }
    case "gearIcon": {
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></svg>
        </>
      )
    }

    default: {
      return <></>;
    }
  }
};

export default SvgIcons;
